import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: number;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ArrayScalar: any;
  /** CNPJ is represented as a string type in the format 00.000.000/0000-00 */
  CNPJScalar: string;
  CPFScalar: string;
  DateScalar: string;
  EmailScalar: string;
  FullNameScalar: any;
  InternationalDateScalar: any;
  JSONScalar: any;
  /** 6 digit code in string format */
  OTPScalar: string;
  PhoneScalar: string;
  /** A SQID (Short Query ID) is a string with the format "AAA_0123456789" */
  SQIDScalar: string;
  TimestampScalar: string;
  URLScalar: string;
  UUID: string;
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: any;
}



export interface ApiPricesInput {
  create_document?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['Float']>;
  sms?: Maybe<Scalars['Float']>;
  whatsapp?: Maybe<Scalars['Float']>;
  whatsapp_otp?: Maybe<Scalars['Float']>;
  documents_query?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['Float']>;
  sign_phone_security_verification?: Maybe<Scalars['Float']>;
  webhook?: Maybe<Scalars['Float']>;
}

export type AcceptSignatureUnion = HashToSign | Signature;

export interface Action {
  name: ActionEnum;
}

export enum ActionEnum {
  Sign = 'SIGN',
  Approve = 'APPROVE',
  Recognize = 'RECOGNIZE',
  SignAsPart = 'SIGN_AS_PART',
  SignAsAWitness = 'SIGN_AS_A_WITNESS',
  SignAsIntervener = 'SIGN_AS_INTERVENER',
  AcknowledgeReceipt = 'ACKNOWLEDGE_RECEIPT',
  EndorseInBlack = 'ENDORSE_IN_BLACK',
  EndorseInWhite = 'ENDORSE_IN_WHITE'
}

export interface AddressInput {
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  ibge_code?: Maybe<Scalars['String']>;
}

export interface Affiliate {
  id?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  referral_code?: Maybe<Scalars['String']>;
  referred_to?: Maybe<Scalars['String']>;
  is_receiving_payments?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  referral_configuration?: Maybe<Scalars['String']>;
  payment_info?: Maybe<Scalars['String']>;
}

export interface ApiOptionsInput {
  webhook_url?: Maybe<Scalars['String']>;
  webhook_format?: WebhookFormatEnum;
}

export interface ApiPricing {
  valid_since?: Maybe<Scalars['TimestampScalar']>;
  currency?: Maybe<Scalars['String']>;
  items?: Maybe<ApiUsageItems>;
}

export interface ApiUsageConfig {
  is_active?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<ApiUsageItems>;
}

export interface ApiUsageConfigInput {
  is_active?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<ApiPricesInput>;
}

export interface ApiUsageItems {
  create_document?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['Float']>;
  sms?: Maybe<Scalars['Float']>;
  whatsapp?: Maybe<Scalars['Float']>;
  whatsapp_otp?: Maybe<Scalars['Float']>;
  documents_query?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['Float']>;
  sign_phone_security_verification?: Maybe<Scalars['Float']>;
  webhook?: Maybe<Scalars['Float']>;
}

export interface ApiUsageLimit {
  alert_threshold?: Maybe<Scalars['Float']>;
  max_limit?: Maybe<Scalars['Float']>;
}

export interface ApiUsagePricing {
  pricing?: Maybe<Array<Maybe<ApiPricing>>>;
  usage?: Maybe<Array<Maybe<OrgApiDailyUsage>>>;
}


export interface Attribute {
  id: Scalars['UUID'];
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
}

export interface AttributeInput {
  id?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  position: Scalars['Int'];
  type: Scalars['String'];
  required: Scalars['Boolean'];
}

export interface AuthType {
  access_token: Scalars['String'];
  token_type: Scalars['String'];
  expires_in: Scalars['Int'];
}

export interface AuthenticationResult {
  access_token: Scalars['String'];
  token_type: Scalars['String'];
  expires_in: Scalars['Int'];
  mfa: Array<Maybe<MfaEnum>>;
}

export interface Author {
  id: Scalars['UUID'];
  organization_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  company?: Maybe<Scalars['String']>;
}

/** Result payload for cloud certificate authorization. */
export interface AuthorizeAppType {
  redirect_url?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
}

export enum BiometricModelEnum {
  /** AWS_FACE_REKOGNITION */
  AwsFaceRekognition = 'AWS_FACE_REKOGNITION'
}

export enum BiometricProvidersEnum {
  /** ID_ANALYZER */
  IdAnalyzer = 'ID_ANALYZER',
  /** BIOMETRIQUE */
  Biometrique = 'BIOMETRIQUE',
  /** DATAVALID */
  Datavalid = 'DATAVALID'
}

export interface BiometriqueConfigsInput {
  biometric_model?: Maybe<BiometricModelEnum>;
  llm_model?: Maybe<LlmModelEnum>;
  ocr_engine?: Maybe<OcrEngineEnum>;
}

export enum BiometriqueResultEnum {
  /** SUCCESS */
  Success = 'SUCCESS',
  /** FAILED */
  Failed = 'FAILED',
  /** QUEUED */
  Queued = 'QUEUED'
}

export interface BiometriqueSignedUrls {
  /** Signed URL for the selfie image */
  selfie?: Maybe<Scalars['URLScalar']>;
  /** Signed URL for the front side of the document */
  front_side?: Maybe<Scalars['URLScalar']>;
  /** Signed URL for the back side of the document */
  back_side?: Maybe<Scalars['URLScalar']>;
}

export interface Block {
  id: Scalars['Int'];
  keyword?: Maybe<Scalars['String']>;
  keyword_type?: Maybe<BlockedKeywordTypeEnum>;
  reason?: Maybe<Scalars['String']>;
  public_reason?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export enum BlockedKeywordTypeEnum {
  /** COMPANY */
  Company = 'COMPANY',
  /** COMPANY_OVERWRITE */
  CompanyOverwrite = 'COMPANY_OVERWRITE',
  /** CNPJ */
  Cnpj = 'CNPJ',
  /** CPF */
  Cpf = 'CPF',
  /** EMAIL */
  Email = 'EMAIL',
  /** EMAIL_DOMAIN */
  EmailDomain = 'EMAIL_DOMAIN',
  /** NAME */
  Name = 'NAME',
  /** PHONE */
  Phone = 'PHONE',
  /** DISPOSABLE_DOMAIN */
  DisposableDomain = 'DISPOSABLE_DOMAIN',
  /** FRAUD_DETECTION */
  FraudDetection = 'FRAUD_DETECTION'
}

export interface BlockedUser {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  company?: Maybe<Scalars['String']>;
  created_at: Scalars['TimestampScalar'];
  is_blocked?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Block>;
}



export interface CampsoftIsp {
  identifier?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
}

export interface CardData {
  last_digits?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
}

export interface ChildOrganizationInput {
  name?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  locale?: Maybe<LocaleInput>;
  default_email_templates_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
}

export interface ChildOrganizationsConfig {
  price?: Maybe<Scalars['Int']>;
  free_count?: Maybe<Scalars['Int']>;
}

export interface ChildOrganizationsConfigInput {
  price?: Maybe<Scalars['Int']>;
  free_count?: Maybe<Scalars['Int']>;
}

export enum CloudSignaturesEnum {
  Safeid = 'SAFEID',
  Vidaas = 'VIDAAS',
  Birdid = 'BIRDID',
  Dscloud = 'DSCLOUD'
}

export interface Contact {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  cpf?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
}

export interface ContactInput {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  cpf?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['PhoneScalar']>;
  /** Your datetime should be in ISO-8601 format */
  birthday?: Maybe<Scalars['String']>;
}

export enum ContextEnum {
  User = 'USER',
  Organization = 'ORGANIZATION',
  Group = 'GROUP'
}

export interface CorporateChildOrganization {
  id: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  type?: Maybe<OrganizationTypeEnum>;
  default_email_templates_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  settings?: Maybe<Setting>;
  groups?: Maybe<Array<Maybe<Group>>>;
  subscription?: Maybe<CorporateChildSubscription>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface CorporateChildOrganizationsFeatures {
  organization_id: Scalars['Int'];
  subscription?: Maybe<CorporateChildSubscription>;
}

export interface CorporateChildSubscription {
  plan_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  documents: Scalars['Int'];
  bonus: Scalars['Int'];
  credits?: Maybe<Scalars['Int']>;
  credits_bonus?: Maybe<Scalars['Int']>;
  has_premium_features: Scalars['Boolean'];
  created_at: Scalars['TimestampScalar'];
  ends_at?: Maybe<Scalars['TimestampScalar']>;
  bought_at?: Maybe<Scalars['TimestampScalar']>;
  expires_at?: Maybe<Scalars['TimestampScalar']>;
  renew_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface CorporateMember {
  id: Scalars['Int'];
  user?: Maybe<User>;
  group?: Maybe<Group>;
  permissions?: Maybe<Permission>;
  api_token?: Maybe<Token>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface CorporateMemberInput {
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  birthday?: Maybe<Scalars['InternationalDateScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  company?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  permissions?: Maybe<PermissionInput>;
  locale?: Maybe<LocaleInput>;
}

export interface CorporateOrganizationPlan {
  organization?: Maybe<Organization>;
  plan?: Maybe<Plan>;
  subscription?: Maybe<Subscription>;
  extra_groups?: Maybe<ExtraGroupsConfig>;
  api_child_organizations?: Maybe<ChildOrganizationsConfig>;
  application_child_organizations?: Maybe<ChildOrganizationsConfig>;
  customer?: Maybe<Customer>;
  api_usage?: Maybe<ApiUsageConfig>;
  enable_whitelabel?: Maybe<Scalars['Boolean']>;
  enable_sub_orgs?: Maybe<Scalars['Boolean']>;
}

export interface CorporatePlan {
  id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  document_amount?: Maybe<Scalars['Int']>;
  credit_amount?: Maybe<Scalars['Int']>;
  credits_recurrence_method?: Maybe<CreditsRecurrenceEnum>;
  interval?: Maybe<Scalars['Int']>;
  interval_type?: Maybe<IntervalTypeEnum>;
  tier?: Maybe<TierEnum>;
}

export interface Coupon {
  name?: Maybe<Scalars['String']>;
  amount_off?: Maybe<Scalars['Int']>;
  percent_off?: Maybe<Scalars['Float']>;
}

export interface CreateEndpointResponse {
  secret: Scalars['String'];
  webhook_endpoint?: Maybe<WebhookEndpoint>;
}

export interface CreditLogType {
  id: Scalars['ID'];
  amount: Scalars['Float'];
  verifications?: Maybe<Scalars['String']>;
  user_email?: Maybe<Scalars['EmailScalar']>;
  user_phone?: Maybe<Scalars['String']>;
  url_nfse?: Maybe<Scalars['String']>;
  document_id?: Maybe<Scalars['UUID']>;
  created_at: Scalars['TimestampScalar'];
}

export interface CreditPackType {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  best?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  amount_promo?: Maybe<Scalars['Float']>;
  is_promo?: Maybe<Scalars['Boolean']>;
}

export interface CreditType {
  value?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Int']>;
}

export enum CreditsRecurrenceEnum {
  /** DETACHED */
  Detached = 'DETACHED',
  /** OVERRIDE */
  Override = 'OVERRIDE'
}

export enum CurrencyEnum {
  /** BRL */
  Brl = 'BRL',
  /** USD */
  Usd = 'USD'
}

export enum CustomPlansEnum {
  Free = 'FREE',
  Professional = 'PROFESSIONAL'
}

export interface Customer {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  ibge_code?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  iugu_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface CustomerInput {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
}

export interface DataSource {
  name?: Maybe<Scalars['String']>;
  voucher?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateScalar']>;
}

export enum DataSourceEnum {
  Cpf = 'CPF',
  Cnpj = 'CNPJ'
}

export enum DateFormatEnum {
  DdMmYyyy = 'DD_MM_YYYY',
  MmDdYyyy = 'MM_DD_YYYY'
}


export interface DefaultEmailTemplates {
  ptBR?: Maybe<EmailTemplate>;
  enUS?: Maybe<EmailTemplate>;
  esMX?: Maybe<EmailTemplate>;
}

export enum DeliveryMethodEnum {
  DeliveryMethodEmail = 'DELIVERY_METHOD_EMAIL',
  DeliveryMethodLink = 'DELIVERY_METHOD_LINK',
  DeliveryMethodSms = 'DELIVERY_METHOD_SMS',
  DeliveryMethodWhatsapp = 'DELIVERY_METHOD_WHATSAPP'
}

export interface Document {
  id: Scalars['UUID'];
  name: Scalars['String'];
  refusable?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  qualified?: Maybe<Scalars['Boolean']>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  sortable?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use deadline_at instead of this attribute */
  is_blocked?: Maybe<Scalars['Boolean']>;
  is_dynamic_document?: Maybe<Scalars['Boolean']>;
  sandbox?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  signers_history?: Maybe<Array<Maybe<SignerHistory>>>;
  locale?: Maybe<Locale>;
  created_at: Scalars['TimestampScalar'];
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
  deadline_at?: Maybe<Scalars['TimestampScalar']>;
  lifecycle_in?: Maybe<Scalars['TimestampScalar']>;
  email_template_id?: Maybe<Scalars['Int']>;
  whatsapp_template?: Maybe<WhatsappTemplateEnum>;
  updated_at: Scalars['TimestampScalar'];
  processed_at?: Maybe<Scalars['TimestampScalar']>;
  expiration_at?: Maybe<Scalars['TimestampScalar']>;
  notify_in?: Maybe<Scalars['Int']>;
  reminder?: Maybe<ReminderEnum>;
  message?: Maybe<Scalars['String']>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  cc?: Maybe<Array<Maybe<Scalars['EmailScalar']>>>;
  reply_to?: Maybe<Scalars['EmailScalar']>;
  configs?: Maybe<DocumentConfig>;
  signatures_count?: Maybe<Scalars['Int']>;
  signed_count?: Maybe<Scalars['Int']>;
  rejected_count?: Maybe<Scalars['Int']>;
  is_from_api?: Maybe<Scalars['Boolean']>;
  signatures?: Maybe<Array<Maybe<Signature>>>;
  watchers?: Maybe<Array<Maybe<Watcher>>>;
  author: Author;
  files?: Maybe<File>;
  hashes?: Maybe<Hash>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
}

export interface DocumentConfig {
  notification_finished?: Maybe<Scalars['Boolean']>;
  notification_signed?: Maybe<Scalars['Boolean']>;
  signature_appearance?: Maybe<SignatureAppearanceEnum>;
  reply_to?: Maybe<Scalars['EmailScalar']>;
  keep_metadata?: Maybe<Scalars['Boolean']>;
  lock_user_data?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  date_format?: Maybe<DateFormatEnum>;
  pdfa?: Maybe<PdfaEnum>;
  notify_watchers?: Maybe<Scalars['Boolean']>;
}

export interface DocumentConfigInput {
  notification_finished?: Maybe<Scalars['Boolean']>;
  notification_signed?: Maybe<Scalars['Boolean']>;
  signature_appearance?: Maybe<SignatureAppearanceEnum>;
  pdfa?: Maybe<Scalars['Boolean']>;
  keep_metadata?: Maybe<Scalars['Boolean']>;
  lock_user_data?: Maybe<Scalars['Boolean']>;
  notify_watchers?: Maybe<Scalars['Boolean']>;
}

export interface DocumentInput {
  name: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  refusable?: Maybe<Scalars['Boolean']>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  qualified?: Maybe<Scalars['Boolean']>;
  sortable?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  reminder?: Maybe<ReminderEnum>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
  /** Your datetime should be in ISO-8601 format */
  deadline_at?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['Int']>;
  whatsapp_template?: Maybe<WhatsappTemplateEnum>;
  expiration?: Maybe<ExpirationInput>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  cc?: Maybe<Array<Maybe<EmailInput>>>;
  reply_to?: Maybe<Scalars['EmailScalar']>;
  locale?: Maybe<LocaleInput>;
  configs?: Maybe<DocumentConfigInput>;
  /** An array of emails to set as watchers to the document */
  watchers?: Maybe<Array<Scalars['String']>>;
}

export enum DocumentReportColumnEnum {
  Name = 'NAME',
  CreatedAt = 'CREATED_AT',
  ExpirationAt = 'EXPIRATION_AT',
  Signatures = 'SIGNATURES',
  Status = 'STATUS',
  Sha = 'SHA',
  Author = 'AUTHOR',
  Link = 'LINK'
}

export interface DocumentSignature {
  document_id: Scalars['UUID'];
  signature_id: Scalars['UUID'];
  signature_public_id: Scalars['UUID'];
  action?: Maybe<Action>;
  type?: Maybe<SignerTypeEnum>;
}

export enum DocumentSignatureTypeEnum {
  Advanced = 'ADVANCED',
  Qualified = 'QUALIFIED',
  Unlocked = 'UNLOCKED'
}

export enum DocumentStatusEnum {
  Pending = 'PENDING',
  Signed = 'SIGNED',
  NotSigned = 'NOT_SIGNED',
  Deleted = 'DELETED',
  Rejected = 'REJECTED'
}

/** The type of document being created */
export enum DocumentTypeEnum {
  /** Standard document type */
  Default = 'DEFAULT',
  /** WhatsApp flow document type that requires .md files */
  WhatsappFlow = 'WHATSAPP_FLOW'
}

export interface DynamicTemplate {
  id?: Maybe<Scalars['String']>;
  user: User;
  name: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  lang?: Maybe<LanguageEnum>;
  theme?: Maybe<DynamicTemplateThemeEnum>;
  category?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_private?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['TimestampScalar'];
  updated_at: Scalars['TimestampScalar'];
  variables?: Maybe<Array<Maybe<DynamicTemplateVariable>>>;
  signers?: Maybe<Array<Maybe<Signer>>>;
}

export interface DynamicTemplateInput {
  id?: Maybe<Scalars['SQIDScalar']>;
  name: Scalars['String'];
  content: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  lang?: Maybe<LanguageEnum>;
  theme?: Maybe<DynamicTemplateThemeEnum>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  category?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
}

export enum DynamicTemplateThemeEnum {
  /** CLASSIC */
  Classic = 'CLASSIC',
  /** MIXED */
  Mixed = 'MIXED',
  /** MODERN */
  Modern = 'MODERN'
}

export interface DynamicTemplateVariable {
  name: Scalars['String'];
  signer_identifier?: Maybe<Scalars['String']>;
  data_signer_id?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
  help_text?: Maybe<Scalars['String']>;
  show_help?: Maybe<Scalars['Boolean']>;
  required?: Maybe<Scalars['Boolean']>;
  regex?: Maybe<Scalars['String']>;
}

export interface DynamicTemplateVariableInput {
  name: Scalars['String'];
  data_signer_id?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  required: Scalars['Boolean'];
  show_help?: Maybe<Scalars['Boolean']>;
  help_text?: Maybe<Scalars['String']>;
  style?: Maybe<StyleInput>;
  regex?: Maybe<Scalars['String']>;
}

export interface EmailEvent {
  id?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['String']>;
  refused?: Maybe<Scalars['String']>;
  delivered?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  author?: Maybe<User>;
  type?: Maybe<EmailTypeEnum>;
}

export interface EmailInput {
  /** inputs.Email.fields.name */
  email: Scalars['String'];
}


export interface EmailTemplate {
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  image?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  footer?: Maybe<Scalars['String']>;
}

export enum EmailTemplateTypeEnum {
  Solicitation = 'SOLICITATION',
  Completed = 'COMPLETED',
  SignatureCompleted = 'SIGNATURE_COMPLETED'
}

export interface EmailTemplates {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateTypeEnum>;
  /** @deprecated Use attributes referring to the specific language instead. */
  email?: Maybe<EmailTemplate>;
  ptBR?: Maybe<EmailTemplate>;
  enUS?: Maybe<EmailTemplate>;
  esMX?: Maybe<EmailTemplate>;
}

export interface EmailTemplatesContentInput {
  title?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  template?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['Upload']>;
  footer?: Maybe<Scalars['String']>;
}

export interface EmailTemplatesInput {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<EmailTemplateTypeEnum>;
  ptBR?: Maybe<EmailTemplatesContentInput>;
  enUS?: Maybe<EmailTemplatesContentInput>;
  esMX?: Maybe<EmailTemplatesContentInput>;
}

export interface EmailType {
  email?: Maybe<Scalars['String']>;
  has_password?: Maybe<Scalars['Boolean']>;
  email_verified_at?: Maybe<Scalars['TimestampScalar']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
}

export enum EmailTypeEnum {
  Solicitation = 'SOLICITATION',
  Reminder = 'REMINDER',
  Resend = 'RESEND'
}

export interface EnterpriseChildOrganization {
  id: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  plan: PipefyPlansEnum;
  default_email_templates_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  settings?: Maybe<Setting>;
  groups?: Maybe<Array<Maybe<Group>>>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface EnterpriseMember {
  id: Scalars['Int'];
  user?: Maybe<User>;
  group?: Maybe<Group>;
  permissions?: Maybe<Permission>;
  api_token?: Maybe<Token>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface EnterpriseMemberInput {
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  birthday?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  group_id?: Maybe<Scalars['Int']>;
  permissions?: Maybe<PermissionInput>;
  locale?: Maybe<LocaleInput>;
}

export interface Escavador {
  body?: Maybe<Scalars['String']>;
}

export interface Event {
  user?: Maybe<UserData>;
  ip?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
  /** @deprecated Use ip intead. */
  ipv4?: Maybe<Scalars['String']>;
  /** @deprecated Use ip intead. */
  ipv6?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  geolocation?: Maybe<Geolocation>;
  field_values?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Autentique's Privacy */
  user_agent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface ExpirationInput {
  days_before: Scalars['Int'];
  notify_at: Scalars['DateScalar'];
}

export interface ExtraGroupsConfig {
  price?: Maybe<Scalars['Int']>;
  free_count?: Maybe<Scalars['Int']>;
}

export interface ExtraGroupsConfigInput {
  price?: Maybe<Scalars['Int']>;
  free_count?: Maybe<Scalars['Int']>;
}

export interface FaceLivenessResult {
  status?: Maybe<LivenessStatusEnum>;
  confidence?: Maybe<Scalars['Float']>;
}

export interface FailedWebhook {
  id?: Maybe<Scalars['String']>;
  webhook_id?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSONScalar']>;
  response_body?: Maybe<Scalars['JSONScalar']>;
  status_code?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  error_class?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  attempts?: Maybe<Scalars['Int']>;
  resolved_at?: Maybe<Scalars['TimestampScalar']>;
  failed_at?: Maybe<Scalars['TimestampScalar']>;
  next_attempt_at?: Maybe<Scalars['TimestampScalar']>;
  ttl?: Maybe<Scalars['TimestampScalar']>;
  webhook_endpoint?: Maybe<WebhookEndpoint>;
}

export enum FallbackBehaviorEnum {
  /** DISABLE_FALLBACK */
  DisableFallback = 'DISABLE_FALLBACK'
}

export interface File {
  original?: Maybe<Scalars['String']>;
  signed?: Maybe<Scalars['String']>;
  certified?: Maybe<Scalars['String']>;
  pades?: Maybe<Scalars['String']>;
}

export interface Folder {
  id: Scalars['UUID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  /** @deprecated Deprecated due to use of context field. */
  type: FolderTypeEnum;
  context: ContextEnum;
  parentFolder?: Maybe<Folder>;
  path?: Maybe<Scalars['String']>;
  subfolders?: Maybe<Array<Maybe<Folder>>>;
  children_counter?: Maybe<Scalars['Int']>;
  is_editor?: Maybe<Scalars['Boolean']>;
  shares?: Maybe<Array<Maybe<FolderShare>>>;
  link_identifier?: Maybe<Scalars['String']>;
  has_password?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['TimestampScalar'];
  updated_at: Scalars['TimestampScalar'];
}

export interface FolderInput {
  name: Scalars['String'];
}

export enum FolderRoleEnum {
  /** EDITOR */
  Editor = 'EDITOR',
  /** VIEWER */
  Viewer = 'VIEWER'
}

export interface FolderShare {
  id?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  group?: Maybe<Group>;
  role?: Maybe<FolderRoleEnum>;
  is_by_link?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
}

export enum FolderTypeEnum {
  Default = 'DEFAULT',
  Organization = 'ORGANIZATION',
  Group = 'GROUP'
}

export enum FontEnum {
  Autograf = 'AUTOGRAF',
  Fathur = 'FATHUR',
  Robertson = 'ROBERTSON'
}

export enum FooterEnum {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum FooterTypeEnum {
  /** STANDARD */
  Standard = 'STANDARD',
  /** MINI */
  Mini = 'MINI'
}

export interface FormInput {
  field_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
}


export interface Geolocation {
  country?: Maybe<Scalars['String']>;
  countryISO?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateISO?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
}

export interface Group {
  id: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  overwrite_template_group?: Maybe<Scalars['Boolean']>;
  overwrite_template?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use email_templates instead. */
  email_template?: Maybe<EmailTemplates>;
  email_templates?: Maybe<Array<Maybe<EmailTemplates>>>;
  permissions?: Maybe<Permission>;
  styles?: Maybe<GroupStyle>;
  /** Autentique's Privacy */
  members?: Maybe<Array<Maybe<Member>>>;
  members_count?: Maybe<Scalars['Int']>;
  is_default?: Maybe<Scalars['Boolean']>;
}

export interface GroupInput {
  name?: Maybe<Scalars['String']>;
  overwrite_template_group?: Maybe<Scalars['Boolean']>;
  overwrite_template?: Maybe<Scalars['Boolean']>;
}

export interface GroupStyle {
  overwrite_email?: Maybe<Scalars['Boolean']>;
  overwrite_name?: Maybe<Scalars['Boolean']>;
}

export interface GroupStyleInput {
  company?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  overwrite_email?: Maybe<Scalars['Boolean']>;
  email_templates_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  overwrite_name?: Maybe<Scalars['Boolean']>;
}

export interface Hash {
  md5?: Maybe<Scalars['String']>;
  sha1?: Maybe<Scalars['String']>;
  sha2?: Maybe<Scalars['String']>;
}

export interface HashToSign {
  hash: Scalars['String'];
}


export enum IntervalTypeEnum {
  /** DAY */
  Day = 'DAY',
  /** WEEK */
  Week = 'WEEK',
  /** MONTH */
  Month = 'MONTH',
  /** YEAR */
  Year = 'YEAR'
}

export interface Invitation {
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  group?: Maybe<Group>;
  permissions?: Maybe<Permission>;
}

export interface Invoice {
  id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['TimestampScalar']>;
  price?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  payment_method?: Maybe<Scalars['String']>;
  type?: Maybe<InvoiceTypeEnum>;
  url_payment?: Maybe<Scalars['String']>;
  url_nfse?: Maybe<Scalars['String']>;
}

export interface InvoicePagination {
  /** List of Invoices on the current page */
  data?: Maybe<Array<Maybe<Invoice>>>;
  /** Number of total Invoices selected by the query */
  total?: Maybe<Scalars['Int']>;
  /** Number of Invoices returned per page */
  per_page: Scalars['Int'];
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** Last page of Invoices */
  last_page?: Maybe<Scalars['Int']>;
  /** Number of the first Invoices returned */
  from?: Maybe<Scalars['Int']>;
  /** Number of the last Invoice returned */
  to?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
}

export enum InvoiceTypeEnum {
  /** SUBSCRIPTION */
  Subscription = 'SUBSCRIPTION',
  /** CREDITS */
  Credits = 'CREDITS',
  /** API */
  Api = 'API',
  /** CORPORATE */
  Corporate = 'CORPORATE'
}

export interface IuguCard {
  id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  data?: Maybe<IuguCardData>;
}

export interface IuguCardData {
  brand?: Maybe<Scalars['String']>;
  holder_name?: Maybe<Scalars['String']>;
  display_number?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  last_digits?: Maybe<Scalars['String']>;
  first_digits?: Maybe<Scalars['String']>;
  masked_number?: Maybe<Scalars['String']>;
}

export interface IuguCardInput {
  set_as_default: Scalars['Boolean'];
  token: Scalars['String'];
  description: Scalars['String'];
}

export interface IuguCharge {
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  pdf?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  bank_slip?: Maybe<IuguChargeBankSlip>;
  credit_card?: Maybe<IuguChargeCreditCard>;
  pix?: Maybe<IuguChargePix>;
  errors?: Maybe<Scalars['String']>;
}

export interface IuguChargeBankSlip {
  digitable_line?: Maybe<Scalars['String']>;
  barcode_data?: Maybe<Scalars['String']>;
  barcode?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  bank_slip_bank?: Maybe<Scalars['Int']>;
  bank_slip_error_code?: Maybe<Scalars['String']>;
  bank_slip_error_message?: Maybe<Scalars['String']>;
}

export interface IuguChargeCreditCard {
  success?: Maybe<Scalars['Boolean']>;
  brand?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  info_message?: Maybe<Scalars['String']>;
}

export interface IuguChargePix {
  qrcode?: Maybe<Scalars['String']>;
  qrcode_text?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  payer_name?: Maybe<Scalars['String']>;
  payer_cpf_cnpj?: Maybe<Scalars['Int']>;
}

export interface IuguCustomer {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  cc_emails?: Maybe<Scalars['String']>;
  cpf_cnpj?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  complement?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phone_prefix?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  default_payment?: Maybe<IuguCard>;
}

export interface IuguInvoice {
  id?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
  total_paid?: Maybe<Scalars['String']>;
  total_cents?: Maybe<Scalars['Int']>;
  total_paid_cents?: Maybe<Scalars['Int']>;
  paid_at?: Maybe<Scalars['TimestampScalar']>;
  payable_with?: Maybe<IuguPaymentEnum>;
  secure_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface IuguOrder {
  active?: Maybe<Scalars['Boolean']>;
  suspended?: Maybe<Scalars['Boolean']>;
  cycled_at?: Maybe<Scalars['TimestampScalar']>;
  expires_at?: Maybe<Scalars['TimestampScalar']>;
  payable_with?: Maybe<IuguPaymentEnum>;
  plan_identifier?: Maybe<Scalars['String']>;
  plan_name?: Maybe<Scalars['String']>;
  price_cents?: Maybe<Scalars['Int']>;
  recent_invoices?: Maybe<Scalars['JSONScalar']>;
  subitems?: Maybe<Array<Maybe<Scalars['JSONScalar']>>>;
}

export interface IuguOrderInput {
  plan: Scalars['String'];
  payable: IuguPaymentEnum;
}

export enum IuguPaymentEnum {
  CreditCard = 'CREDIT_CARD',
  BankSlip = 'BANK_SLIP',
  Pix = 'PIX',
  All = 'ALL'
}

export interface IuguPlan {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  documents?: Maybe<Scalars['Int']>;
  hidden?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
}


export enum LlmModelEnum {
  /** GEMINI_2_5_FLASH */
  Gemini_2_5Flash = 'GEMINI_2_5_FLASH',
  /** GEMINI_2_5_FLASH_LITE */
  Gemini_2_5FlashLite = 'GEMINI_2_5_FLASH_LITE'
}

export enum LanguageEnum {
  /** PT_BR */
  PtBr = 'PT_BR',
  /** EN_US */
  EnUs = 'EN_US',
  /** ES_MX */
  EsMx = 'ES_MX'
}

export interface Link {
  id: Scalars['String'];
  short_link?: Maybe<Scalars['String']>;
}

export enum LivenessStatusEnum {
  /** CREATED */
  Created = 'CREATED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** SUCCEEDED */
  Succeeded = 'SUCCEEDED',
  /** FAILED */
  Failed = 'FAILED',
  /** EXPIRED */
  Expired = 'EXPIRED'
}

export interface Locale {
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  date_format?: Maybe<DateFormatEnum>;
}

export interface LocaleInput {
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  date_format?: Maybe<DateFormatEnum>;
}

export interface LockSignature {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  delivery_method?: Maybe<Scalars['String']>;
  configs?: Maybe<LockSignatureConfig>;
  security_verifications?: Maybe<Array<Maybe<SecurityVerificationType>>>;
  action?: Maybe<ActionEnum>;
  show_options?: Maybe<Scalars['Boolean']>;
  show_sms_verification?: Maybe<Scalars['Boolean']>;
  show_security_verifications?: Maybe<Scalars['Boolean']>;
  show_cpf_verification?: Maybe<Scalars['Boolean']>;
  qualified_signature?: Maybe<Scalars['Boolean']>;
}

export interface LockSignatureConfig {
  cpf?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  prefilled_fields?: Maybe<PrefilledFields>;
}

export interface LockSignerInput {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['PhoneScalar']>;
  delivery_method?: Maybe<Scalars['String']>;
  configs?: Maybe<SignerConfigInput>;
  security_verifications?: Maybe<Array<Maybe<SecurityVerificationInput>>>;
  action?: Maybe<ActionEnum>;
  show_options?: Maybe<Scalars['Boolean']>;
  show_sms_verification?: Maybe<Scalars['Boolean']>;
  show_security_verifications?: Maybe<Scalars['Boolean']>;
  show_cpf_verification?: Maybe<Scalars['Boolean']>;
  qualified_signature?: Maybe<Scalars['Boolean']>;
}

export interface Member {
  /** @deprecated Deprecated in this version. */
  id: Scalars['String'];
  /** @deprecated Deprecated in this version. */
  name?: Maybe<Scalars['String']>;
  /** @deprecated Deprecated in this version. */
  email?: Maybe<Scalars['EmailScalar']>;
  /** @deprecated Deprecated in this version. */
  role?: Maybe<Role>;
  user?: Maybe<User>;
  /** Autentique's Privacy */
  organization?: Maybe<Organization>;
  group?: Maybe<Group>;
  permissions?: Maybe<Permission>;
  configs?: Maybe<MemberConfigs>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface MemberConfigs {
  notification_signed?: Maybe<Scalars['Boolean']>;
  notification_finished?: Maybe<Scalars['Boolean']>;
  email_template?: Maybe<Scalars['Int']>;
  whatsapp_template?: Maybe<WhatsappTemplateEnum>;
  locked_signers?: Maybe<Array<Maybe<LockSignature>>>;
  locked_cc?: Maybe<Array<Maybe<Scalars['EmailScalar']>>>;
  locked_reply_to?: Maybe<Scalars['EmailScalar']>;
  locked_watchers?: Maybe<Array<Maybe<Scalars['EmailScalar']>>>;
  folder?: Maybe<Folder>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Locale>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  ordered_signatures?: Maybe<Scalars['Boolean']>;
  signature_type?: Maybe<DocumentSignatureTypeEnum>;
}

export interface MemberConfigsInput {
  email_template?: Maybe<Scalars['Int']>;
  whatsapp_template?: Maybe<WhatsappTemplateEnum>;
  locked_signers?: Maybe<Array<LockSignerInput>>;
  notification_signed?: Maybe<Scalars['Boolean']>;
  notification_finished?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<LocaleInput>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  folder_id?: Maybe<Scalars['String']>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  locked_cc?: Maybe<Array<Maybe<Scalars['EmailScalar']>>>;
  locked_reply_to?: Maybe<Scalars['EmailScalar']>;
  locked_watchers?: Maybe<Array<Maybe<Scalars['EmailScalar']>>>;
  ordered_signatures?: Maybe<Scalars['Boolean']>;
  signature_type?: Maybe<DocumentSignatureTypeEnum>;
}

export interface MemberInput {
  email?: Maybe<Scalars['EmailScalar']>;
  group_id?: Maybe<Scalars['Int']>;
  permissions?: Maybe<PermissionInput>;
}

export enum MfaEnum {
  Totp = 'totp'
}

export interface Mutation {
  viewSignature?: Maybe<PublicSignature>;
  rejectSignature?: Maybe<PublicSignature>;
  prepareBiometricAuth: Scalars['String'];
  createUserBiometricLivenessSession?: Maybe<Scalars['String']>;
  checkUserBiometricLivenessResults?: Maybe<FaceLivenessResult>;
  executeUserBiometricValidation?: Maybe<UserBiometricValidation>;
}


export interface MutationViewSignatureArgs {
  id: Scalars['UUID'];
}


export interface MutationRejectSignatureArgs {
  id: Scalars['UUID'];
  type: TypeEnum;
  reason?: Maybe<Scalars['String']>;
}


export interface MutationPrepareBiometricAuthArgs {
  security_verification_id: Scalars['Int'];
  document_id: Scalars['UUID'];
}


export interface MutationCreateUserBiometricLivenessSessionArgs {
  operation_id: Scalars['String'];
}


export interface MutationCheckUserBiometricLivenessResultsArgs {
  operation_id: Scalars['String'];
}


export interface MutationExecuteUserBiometricValidationArgs {
  operation_id: Scalars['String'];
  configs?: Maybe<BiometriqueConfigsInput>;
}

export interface Notification {
  signature_you: Scalars['Boolean'];
  signature_others: Scalars['Boolean'];
  signature_approval: Scalars['Boolean'];
}

export interface NotificationInput {
  signature_you: Scalars['Boolean'];
  signature_others: Scalars['Boolean'];
  signature_approval: Scalars['Boolean'];
}

export interface OAuthClient {
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon_url?: Maybe<Scalars['String']>;
  redirect_uris: Array<Scalars['URLScalar']>;
  scopes: Array<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface OAuthClientInput {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['Upload']>;
  redirect_uris?: Maybe<Array<Scalars['URLScalar']>>;
  scopes?: Maybe<Array<Scalars['String']>>;
}

export interface OAuthScope {
  id: Scalars['String'];
  description: Scalars['String'];
}

export interface OAuthToken {
  id: Scalars['String'];
  client_id: Scalars['String'];
  client_name: Scalars['String'];
  client_icon_url?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['TimestampScalar']>;
  granted_scopes: Array<Scalars['String']>;
}

export enum OcrEngineEnum {
  /** DOCUMENT_AI */
  DocumentAi = 'DOCUMENT_AI'
}


export interface Order {
  plan_id?: Maybe<Scalars['String']>;
  plan_name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  suspended?: Maybe<Scalars['Boolean']>;
  payment_method?: Maybe<PaymentMethodsEnum>;
  card_data?: Maybe<CardData>;
  subitems?: Maybe<Array<Maybe<OrderSubItem>>>;
  latest_invoice?: Maybe<Invoice>;
  coupon?: Maybe<Coupon>;
  cycled_at?: Maybe<Scalars['TimestampScalar']>;
  expires_at?: Maybe<Scalars['TimestampScalar']>;
  gateway?: Maybe<PaymentGatewayEnum>;
}

export interface OrderBy {
  field: Scalars['String'];
  direction: OrderByEnum;
}

export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface OrderSubItem {
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
}

export interface OrgApiDailyUsage {
  day?: Maybe<Scalars['TimestampScalar']>;
  items?: Maybe<ApiUsageItems>;
}

export interface Organization {
  id: Scalars['Int'];
  uuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  type?: Maybe<OrganizationTypeEnum>;
  /** @deprecated Deprecated after stripe integration. */
  customer_id?: Maybe<Scalars['String']>;
  settings?: Maybe<Setting>;
  parent?: Maybe<ParentOrganization>;
  /** @deprecated Deprecated in this version. */
  overwrite_email: Scalars['Boolean'];
  /** @deprecated Deprecated in this version. */
  overwrite_template: Scalars['Boolean'];
  /** @deprecated Deprecated in this version. */
  overwrite_name: Scalars['Boolean'];
  /** Autentique's Privacy */
  groups?: Maybe<Array<Maybe<Group>>>;
  subscription?: Maybe<Subscription>;
  billing_customer?: Maybe<Customer>;
  /** @deprecated Use locale.country instead. */
  country?: Maybe<Scalars['String']>;
  locale?: Maybe<Locale>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface OrganizationInput {
  name?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  locale?: Maybe<LocaleInput>;
}

export enum OrganizationTypeEnum {
  /** API_ONLY */
  ApiOnly = 'API_ONLY'
}

export interface OrganizationUsageReport {
  documents?: Maybe<Scalars['Int']>;
  credits?: Maybe<Scalars['Int']>;
}

export enum PdfaEnum {
  /** V_1A */
  V_1A = 'V_1A',
  /** V_1B */
  V_1B = 'V_1B',
  /** V_2A */
  V_2A = 'V_2A',
  /** V_2B */
  V_2B = 'V_2B',
  /** V_2U */
  V_2U = 'V_2U',
  /** V_3A */
  V_3A = 'V_3A',
  /** V_3B */
  V_3B = 'V_3B',
  /** V_3U */
  V_3U = 'V_3U'
}

export enum PadesActionEnum {
  Start = 'START',
  Complete = 'COMPLETE'
}

export interface ParentOrganization {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
}

export interface PasswordInput {
  current?: Maybe<Scalars['String']>;
  new?: Maybe<Scalars['String']>;
  new_confirmation?: Maybe<Scalars['String']>;
}

export enum PaymentGatewayEnum {
  Iugu = 'IUGU',
  Stripe = 'STRIPE'
}

export enum PaymentMethodsEnum {
  CreditCard = 'CREDIT_CARD',
  Boleto = 'BOLETO',
  Pix = 'PIX',
  All = 'ALL'
}

export interface Permission {
  overwrite_permissions?: Maybe<Scalars['Boolean']>;
  create_documents?: Maybe<Scalars['Boolean']>;
  sign_documents?: Maybe<Scalars['Boolean']>;
  delete_documents?: Maybe<Scalars['Boolean']>;
  archive_documents?: Maybe<Scalars['Boolean']>;
  view_documents_gr?: Maybe<Scalars['Boolean']>;
  view_folders_gr?: Maybe<Scalars['Boolean']>;
  actions_folders_gr?: Maybe<Scalars['Boolean']>;
  actions_documents_gr?: Maybe<Scalars['Boolean']>;
  actions_templates_gr?: Maybe<Scalars['Boolean']>;
  actions_members_oz?: Maybe<Scalars['Boolean']>;
  actions_groups_oz?: Maybe<Scalars['Boolean']>;
  actions_webhooks_oz?: Maybe<Scalars['Boolean']>;
  actions_applications_oz?: Maybe<Scalars['Boolean']>;
  view_documents_oz?: Maybe<Scalars['Boolean']>;
  view_member_documents_oz?: Maybe<Scalars['Boolean']>;
  view_group_documents_oz?: Maybe<Scalars['Boolean']>;
  view_folders_oz?: Maybe<Scalars['Boolean']>;
  view_member_folders_oz?: Maybe<Scalars['Boolean']>;
  view_group_folders_oz?: Maybe<Scalars['Boolean']>;
  actions_documents_oz?: Maybe<Scalars['Boolean']>;
  view_invoices_oz?: Maybe<Scalars['Boolean']>;
  change_plan_oz?: Maybe<Scalars['Boolean']>;
  actions_folders_oz?: Maybe<Scalars['Boolean']>;
  change_appearances_oz?: Maybe<Scalars['Boolean']>;
  change_whitelabel_oz?: Maybe<Scalars['Boolean']>;
  enterprise_access?: Maybe<Scalars['Boolean']>;
  validate_biometry?: Maybe<Scalars['Boolean']>;
}

export interface PermissionInput {
  overwrite_permissions?: Maybe<Scalars['Boolean']>;
  create_documents?: Maybe<Scalars['Boolean']>;
  sign_documents?: Maybe<Scalars['Boolean']>;
  delete_documents?: Maybe<Scalars['Boolean']>;
  archive_documents?: Maybe<Scalars['Boolean']>;
  view_documents_gr?: Maybe<Scalars['Boolean']>;
  view_folders_gr?: Maybe<Scalars['Boolean']>;
  actions_folders_gr?: Maybe<Scalars['Boolean']>;
  actions_documents_gr?: Maybe<Scalars['Boolean']>;
  actions_templates_gr?: Maybe<Scalars['Boolean']>;
  actions_members_oz?: Maybe<Scalars['Boolean']>;
  actions_groups_oz?: Maybe<Scalars['Boolean']>;
  actions_webhooks_oz?: Maybe<Scalars['Boolean']>;
  actions_applications_oz?: Maybe<Scalars['Boolean']>;
  view_documents_oz?: Maybe<Scalars['Boolean']>;
  view_member_documents_oz?: Maybe<Scalars['Boolean']>;
  view_group_documents_oz?: Maybe<Scalars['Boolean']>;
  view_folders_oz?: Maybe<Scalars['Boolean']>;
  view_member_folders_oz?: Maybe<Scalars['Boolean']>;
  view_group_folders_oz?: Maybe<Scalars['Boolean']>;
  actions_documents_oz?: Maybe<Scalars['Boolean']>;
  view_invoices_oz?: Maybe<Scalars['Boolean']>;
  change_plan_oz?: Maybe<Scalars['Boolean']>;
  actions_folders_oz?: Maybe<Scalars['Boolean']>;
  change_appearances_oz?: Maybe<Scalars['Boolean']>;
  validate_biometry?: Maybe<Scalars['Boolean']>;
}


export enum PipefyPlansEnum {
  Free = 'FREE',
  Unlimited = 'UNLIMITED'
}

export interface Plan {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Int']>;
  api_credit_threshold?: Maybe<Scalars['Int']>;
  extra_features_price?: Maybe<Scalars['Int']>;
  extra_features_installments?: Maybe<Scalars['Int']>;
  document_amount?: Maybe<Scalars['Int']>;
  credit_amount?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
  active?: Maybe<Scalars['Boolean']>;
  interval_type?: Maybe<IntervalTypeEnum>;
  currency?: Maybe<Scalars['String']>;
  stripe_id?: Maybe<Scalars['String']>;
  iugu_id?: Maybe<Scalars['String']>;
}

export enum PositionElementEnum {
  Signature = 'SIGNATURE',
  Name = 'NAME',
  Initials = 'INITIALS',
  Date = 'DATE',
  Cpf = 'CPF'
}

export interface PositionInput {
  x: Scalars['String'];
  y: Scalars['String'];
  z: Scalars['Int'];
  angle?: Maybe<Scalars['Float']>;
  element?: Maybe<PositionElementEnum>;
  scale?: Maybe<Scalars['Float']>;
}

export interface PositionType {
  x: Scalars['String'];
  y: Scalars['String'];
  z: Scalars['Int'];
  angle?: Maybe<Scalars['Float']>;
  element?: Maybe<PositionElementEnum>;
}

export interface PrefilledFields {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['PhoneScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  birthdate?: Maybe<Scalars['InternationalDateScalar']>;
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
}

export interface PrefilledFieldsInput {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['PhoneScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  birthdate?: Maybe<Scalars['InternationalDateScalar']>;
  country?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
}

export interface Provider {
  name: Scalars['String'];
}

export interface PublicDocument {
  id: Scalars['UUID'];
  name: Scalars['String'];
  refusable?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  qualified?: Maybe<Scalars['Boolean']>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  sortable?: Maybe<Scalars['Boolean']>;
  is_blocked?: Maybe<Scalars['Boolean']>;
  is_dynamic_document?: Maybe<Scalars['Boolean']>;
  sandbox?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  signers_history?: Maybe<Array<Maybe<SignerHistory>>>;
  created_at: Scalars['TimestampScalar'];
  deadline_at?: Maybe<Scalars['TimestampScalar']>;
  lifecycle_in?: Maybe<Scalars['TimestampScalar']>;
  email_template_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['TimestampScalar'];
  expiration_at?: Maybe<Scalars['TimestampScalar']>;
  notify_in?: Maybe<Scalars['Int']>;
  reminder?: Maybe<ReminderEnum>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  configs?: Maybe<DocumentConfig>;
  is_from_api?: Maybe<Scalars['Boolean']>;
  signatures?: Maybe<Array<Maybe<PublicSignature>>>;
  author: Author;
  files?: Maybe<File>;
  hashes?: Maybe<Hash>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Locale>;
}

export interface PublicFolder {
  id: Scalars['UUID'];
  name: Scalars['String'];
  link_identifier?: Maybe<Scalars['String']>;
  has_password?: Maybe<Scalars['Boolean']>;
  is_allowed_user?: Maybe<Scalars['Boolean']>;
}

export interface PublicSignature {
  public_id?: Maybe<Scalars['UUID']>;
  dynamic_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  delivery_method?: Maybe<DeliveryMethodEnum>;
  type?: Maybe<SignerTypeEnum>;
  email_events?: Maybe<EmailEvent>;
  email_history?: Maybe<Array<Maybe<EmailEvent>>>;
  signature_history?: Maybe<Array<Maybe<SignatureHistory>>>;
  positions?: Maybe<Array<Maybe<SignaturePosition>>>;
  configs?: Maybe<SignatureConfig>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  archived_at?: Maybe<Scalars['TimestampScalar']>;
  certificate?: Maybe<SignedCertificate>;
  viewed?: Maybe<Event>;
  signed?: Maybe<Event>;
  fields_filled?: Maybe<Event>;
  rejected?: Maybe<Event>;
  signed_unapproved?: Maybe<Event>;
  biometric_approved?: Maybe<Event>;
  biometric_rejected?: Maybe<Event>;
  biometric_auto_rejected?: Maybe<Event>;
  biometric_reset?: Maybe<Event>;
  parent?: Maybe<Scalars['String']>;
  action?: Maybe<Action>;
  document: PublicDocument;
  user?: Maybe<PublicUser>;
  user_data?: Maybe<UserData>;
  verifications?: Maybe<Array<Maybe<SecurityVerificationType>>>;
}

export interface PublicUser {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['TimestampScalar']>;
  hp_set?: Maybe<Scalars['Boolean']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  company?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateScalar']>;
  escavador?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  member?: Maybe<Member>;
  created_at: Scalars['TimestampScalar'];
  /** @deprecated Deprecated in this version. */
  auth_methods?: Maybe<Array<Maybe<Provider>>>;
  settings?: Maybe<Setting>;
  /** @deprecated Deprecated in this version. */
  group?: Maybe<Group>;
}

export interface Query {
  userExist?: Maybe<Scalars['Boolean']>;
  document?: Maybe<PublicDocument>;
  signature: PublicSignature;
  signatures?: Maybe<Array<Maybe<DocumentSignature>>>;
  signatureByLink?: Maybe<PublicSignature>;
  signatureBySecurityVerificationCode?: Maybe<Scalars['String']>;
  organizationInvoices?: Maybe<InvoicePagination>;
  documentEmailHistory?: Maybe<PublicDocument>;
  whitelabelByDomain?: Maybe<Whitelabel>;
  whitelabelByDocument?: Maybe<Whitelabel>;
  biometricSignedUrls?: Maybe<BiometriqueSignedUrls>;
  userBiometricValidation?: Maybe<UserBiometricValidation>;
}


export interface QueryUserExistArgs {
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['PhoneScalar']>;
}


export interface QueryDocumentArgs {
  id?: Maybe<Scalars['UUID']>;
  public_id?: Maybe<Scalars['UUID']>;
}


export interface QuerySignatureArgs {
  id: Scalars['UUID'];
}


export interface QuerySignaturesArgs {
  id: Scalars['UUID'];
}


export interface QuerySignatureByLinkArgs {
  id: Scalars['UUID'];
}


export interface QuerySignatureBySecurityVerificationCodeArgs {
  code?: Maybe<Scalars['String']>;
}


export interface QueryOrganizationInvoicesArgs {
  organization_uuid?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
}


export interface QueryDocumentEmailHistoryArgs {
  id: Scalars['UUID'];
}


export interface QueryWhitelabelByDomainArgs {
  domain?: Maybe<Scalars['String']>;
}


export interface QueryWhitelabelByDocumentArgs {
  document_id: Scalars['UUID'];
}


export interface QueryBiometricSignedUrlsArgs {
  operation_id: Scalars['String'];
}


export interface QueryUserBiometricValidationArgs {
  operation_id: Scalars['String'];
}

export interface Referral {
  id?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  referral_code?: Maybe<Scalars['String']>;
  referral_to?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['Float']>;
  is_receiving_payments?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  affiliates?: Maybe<Array<Maybe<Affiliate>>>;
  referral_configuration?: Maybe<Scalars['String']>;
  payment_info?: Maybe<Scalars['String']>;
  monthly_amount?: Maybe<Scalars['String']>;
  recent_extracts?: Maybe<Scalars['String']>;
}

export enum ReminderEnum {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export interface Role {
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}

export enum RoleEnum {
  Admin = 'ADMIN',
  User = 'USER'
}


export enum SecurityVerificationEnum {
  Sms = 'SMS',
  Upload = 'UPLOAD',
  Live = 'LIVE',
  PfFacial = 'PF_FACIAL',
  PfFacialMatch = 'PF_FACIAL_MATCH',
  Manual = 'MANUAL',
  BiometricAndTextExtraction = 'BIOMETRIC_AND_TEXT_EXTRACTION',
  LivenessAndTextExtraction = 'LIVENESS_AND_TEXT_EXTRACTION'
}

export interface SecurityVerificationExtractedDataType {
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  date_of_birth?: Maybe<Scalars['DateScalar']>;
  nationality?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
}

export enum SecurityVerificationFileTypeEnum {
  Selfie = 'SELFIE',
  Front = 'FRONT',
  Back = 'BACK'
}

export interface SecurityVerificationInput {
  type?: Maybe<SecurityVerificationEnum>;
  verify_phone?: Maybe<Scalars['PhoneScalar']>;
  fallback_behavior?: Maybe<FallbackBehaviorEnum>;
  max_attempts?: Maybe<Scalars['Int']>;
}

export interface SecurityVerificationPayloadType {
  url?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  session_id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['TimestampScalar']>;
  failcode?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
}

export interface SecurityVerificationType {
  id?: Maybe<Scalars['Int']>;
  type?: Maybe<SecurityVerificationEnum>;
  verify_phone?: Maybe<Scalars['String']>;
  payload?: Maybe<SecurityVerificationPayloadType>;
  user?: Maybe<SecurityVerificationUserType>;
  verified_at?: Maybe<Scalars['TimestampScalar']>;
  max_attempt?: Maybe<Scalars['Int']>;
  logs_attempt?: Maybe<Scalars['ArrayScalar']>;
  fallback_behavior?: Maybe<FallbackBehaviorEnum>;
}

export interface SecurityVerificationUserType {
  images?: Maybe<Scalars['JSONScalar']>;
  confidence?: Maybe<Scalars['Float']>;
  extracted_data?: Maybe<SecurityVerificationExtractedDataType>;
  verified?: Maybe<Scalars['Boolean']>;
}

export interface Session {
  ip_address?: Maybe<Scalars['String']>;
  user_agent?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface Setting {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<EmailTemplate>;
  format?: Maybe<Scalars['String']>;
  webhook_url?: Maybe<Scalars['String']>;
  webhook_format?: Maybe<WebhookFormatEnum>;
  signature?: Maybe<Scalars['String']>;
  signature_draw?: Maybe<Scalars['String']>;
  initials_format?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  initials_draw?: Maybe<Scalars['String']>;
  initials_text?: Maybe<Scalars['String']>;
  font?: Maybe<Scalars['String']>;
  signature_text?: Maybe<Scalars['String']>;
  has_signature_appearance?: Maybe<Scalars['Boolean']>;
  has_initials_appearance?: Maybe<Scalars['Boolean']>;
  developer?: Maybe<Scalars['Boolean']>;
}

export interface ShareFolderInput {
  email?: Maybe<Scalars['EmailScalar']>;
  group_id?: Maybe<Scalars['Int']>;
  role?: FolderRoleEnum;
}

export interface Signature {
  public_id?: Maybe<Scalars['UUID']>;
  dynamic_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  delivery_method?: Maybe<DeliveryMethodEnum>;
  type?: Maybe<SignerTypeEnum>;
  email_events?: Maybe<EmailEvent>;
  email_history?: Maybe<Array<Maybe<EmailEvent>>>;
  positions?: Maybe<Array<Maybe<SignaturePosition>>>;
  configs?: Maybe<SignatureConfig>;
  organization_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  archived_at?: Maybe<Scalars['TimestampScalar']>;
  action?: Maybe<Action>;
  link?: Maybe<Link>;
  certificate?: Maybe<SignedCertificate>;
  viewed?: Maybe<Event>;
  signed?: Maybe<Event>;
  rejected?: Maybe<Event>;
  signed_unapproved?: Maybe<Event>;
  biometric_approved?: Maybe<Event>;
  biometric_rejected?: Maybe<Event>;
  fields_filled?: Maybe<Event>;
  biometric_auto_rejected?: Maybe<Event>;
  biometric_reset?: Maybe<Event>;
  user?: Maybe<User>;
  user_data?: Maybe<UserData>;
  parent?: Maybe<Scalars['String']>;
  verifications?: Maybe<Array<Maybe<SecurityVerificationType>>>;
  folder?: Maybe<Folder>;
  /** Autentique's Privacy */
  organization?: Maybe<Organization>;
}

export enum SignatureAppearanceEnum {
  Draw = 'DRAW',
  Handwriting = 'HANDWRITING',
  Eletronic = 'ELETRONIC',
  Image = 'IMAGE'
}

export interface SignatureConfig {
  overwrite_name?: Maybe<Scalars['String']>;
  overwrite_date?: Maybe<Scalars['DateScalar']>;
  cpf?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  prefilled_fields?: Maybe<PrefilledFields>;
  name?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['InternationalDateScalar']>;
  session_behavior?: Maybe<SignatureSessionBehaviorEnum>;
}

export interface SignatureConfigInput {
  overwrite_name?: Maybe<Scalars['String']>;
  overwrite_date?: Maybe<Scalars['String']>;
  session_behavior?: Maybe<SignatureSessionBehaviorEnum>;
}

export interface SignatureHistory {
  id?: Maybe<Scalars['String']>;
  type?: Maybe<DeliveryMethodEnum>;
  sent?: Maybe<Scalars['String']>;
  delivered?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['String']>;
  refused?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  email_type?: Maybe<EmailTypeEnum>;
  phone?: Maybe<Scalars['PhoneScalar']>;
  user?: Maybe<PublicUser>;
}

export interface SignatureInput {
  email?: Maybe<Scalars['EmailScalar']>;
  positions?: Maybe<Array<Maybe<PositionInput>>>;
  configs?: Maybe<SignatureConfigInput>;
}

export interface SignaturePosition {
  x: Scalars['String'];
  y: Scalars['String'];
  z: Scalars['Int'];
  angle?: Maybe<Scalars['Float']>;
  element?: Maybe<PositionElementEnum>;
  scale?: Maybe<Scalars['Float']>;
}

export enum SignatureSessionBehaviorEnum {
  /** KEEP_SESSION */
  KeepSession = 'KEEP_SESSION',
  /** EPHEMERAL_SESSION */
  EphemeralSession = 'EPHEMERAL_SESSION'
}

export enum SignatureTypesEnum {
  A1 = 'A1',
  A3 = 'A3',
  Safeid = 'SAFEID',
  Vidaas = 'VIDAAS',
  Birdid = 'BIRDID',
  Dscloud = 'DSCLOUD'
}

export interface SignedCertificate {
  type?: Maybe<SignatureTypesEnum>;
  name?: Maybe<Scalars['String']>;
  /** Document number (TAX ID) */
  document?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  /** Certificate payload in PEM format. */
  payload?: Maybe<Scalars['String']>;
}

export interface Signer {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  delivery_method?: Maybe<DeliveryMethodEnum>;
  positions?: Maybe<Array<Maybe<PositionType>>>;
  action?: Maybe<ActionEnum>;
  configs?: Maybe<SignerConfig>;
  variable_id?: Maybe<Scalars['Int']>;
  security_verifications?: Maybe<Array<Maybe<SecurityVerificationType>>>;
}

export interface SignerConfig {
  name?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  birthdate?: Maybe<Scalars['InternationalDateScalar']>;
  prefilled_fields?: Maybe<PrefilledFields>;
}

export interface SignerConfigInput {
  name?: Maybe<Scalars['FullNameScalar']>;
  cpf?: Maybe<Scalars['String']>;
  cnpj?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['InternationalDateScalar']>;
  prefilled_fields?: Maybe<PrefilledFieldsInput>;
  session_behavior?: Maybe<SignatureSessionBehaviorEnum>;
}

export interface SignerFieldsInput {
  public_id: Scalars['UUID'];
  field_values: Array<Maybe<Scalars['String']>>;
}

export interface SignerHistory {
  created_at?: Maybe<Scalars['TimestampScalar']>;
  user?: Maybe<PublicSignature>;
  author?: Maybe<PublicSignature>;
  category?: Maybe<SignerHistoryEnum>;
}

export enum SignerHistoryEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  GenerateLink = 'GENERATE_LINK'
}

export interface SignerInput {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  delivery_method?: Maybe<DeliveryMethodEnum>;
  positions?: Maybe<Array<Maybe<PositionInput>>>;
  action: ActionEnum;
  type?: Maybe<SignerTypeEnum>;
  configs?: Maybe<SignerConfigInput>;
  variable_id?: Maybe<Scalars['Int']>;
  security_verifications?: Maybe<Array<Maybe<SecurityVerificationInput>>>;
}

export enum SignerTypeEnum {
  /** STANDARD */
  Standard = 'STANDARD',
  /** QUALIFIED */
  Qualified = 'QUALIFIED'
}

export interface Social {
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  deleted_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface SpamIncident {
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  action?: Maybe<SpamIncidentActionEnum>;
  signers_today?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
}

export enum SpamIncidentActionEnum {
  Pending = 'PENDING',
  Ignore = 'IGNORE',
  AllowAll = 'ALLOW_ALL',
  BlockUser = 'BLOCK_USER'
}

export interface Statistic {
  documents: Scalars['Int'];
  sent: Scalars['Int'];
  signatures: Scalars['Int'];
}

export interface Storage {
  path: Scalars['String'];
  pdfa?: Maybe<PdfaEnum>;
  size?: Maybe<Scalars['Int']>;
}

export interface Style {
  block?: Maybe<Scalars['Int']>;
  bold?: Maybe<Scalars['Boolean']>;
  italic?: Maybe<Scalars['Boolean']>;
  decoration?: Maybe<Scalars['String']>;
}

export interface StyleInput {
  block?: Maybe<Scalars['Int']>;
  bold?: Maybe<Scalars['Boolean']>;
  italic?: Maybe<Scalars['Boolean']>;
  decoration?: Maybe<Scalars['String']>;
}

export interface Subscription {
  name?: Maybe<Scalars['String']>;
  documents: Scalars['Int'];
  credits?: Maybe<Scalars['Int']>;
  credits_bonus?: Maybe<Scalars['Int']>;
  bonus: Scalars['Int'];
  has_premium_features: Scalars['Boolean'];
  has_corporate_features?: Maybe<Scalars['Boolean']>;
  gateway_name?: Maybe<Scalars['String']>;
  gateway_id?: Maybe<Scalars['String']>;
  plan_id?: Maybe<Scalars['String']>;
  first_invoice_due_at?: Maybe<Scalars['InternationalDateScalar']>;
  due_day?: Maybe<Scalars['Int']>;
  /** @deprecated Use `gateway_id` field instead. */
  iugu_id?: Maybe<Scalars['String']>;
  /** @deprecated Use `plan_id` field instead. */
  iugu_plan?: Maybe<Scalars['String']>;
  created_at: Scalars['TimestampScalar'];
  ends_at?: Maybe<Scalars['TimestampScalar']>;
  bought_at?: Maybe<Scalars['TimestampScalar']>;
  expires_at?: Maybe<Scalars['TimestampScalar']>;
  renew_at?: Maybe<Scalars['TimestampScalar']>;
}

export interface SubscriptionPlanInput {
  display_name?: Maybe<Scalars['String']>;
  document_amount?: Maybe<Scalars['Int']>;
  credit_amount?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
  interval_type?: Maybe<IntervalTypeEnum>;
  tier?: Maybe<TierEnum>;
  credits_recurrence_method?: Maybe<CreditsRecurrenceEnum>;
}

export interface Totp {
  secret: Scalars['String'];
  qr_code: Scalars['String'];
}

export interface Template {
  id: Scalars['UUID'];
  user: User;
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  created_at: Scalars['TimestampScalar'];
  updated_at: Scalars['TimestampScalar'];
  attributes?: Maybe<Array<Maybe<Attribute>>>;
}

export interface TemplateInput {
  id?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  text: Scalars['String'];
}

export enum TierEnum {
  /** FREE */
  Free = 'FREE',
  /** PROFESSIONAL */
  Professional = 'PROFESSIONAL'
}


export interface Token {
  access_token: Scalars['String'];
  token_type: Scalars['String'];
  env: Scalars['String'];
  parent_organization_id?: Maybe<Scalars['Int']>;
  parent_organization_name?: Maybe<Scalars['String']>;
  created_at: Scalars['TimestampScalar'];
}

export interface TokenInput {
  name: Scalars['String'];
}

export enum TypeEnum {
  Link = 'LINK',
  Signature = 'SIGNATURE'
}



export interface UpdateDocumentInput {
  name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  refusable?: Maybe<Scalars['Boolean']>;
  ignore_cpf?: Maybe<Scalars['Boolean']>;
  ignore_birthdate?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  sortable?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  reminder?: Maybe<ReminderEnum>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
  expiration?: Maybe<ExpirationInput>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  cc?: Maybe<Array<Maybe<EmailInput>>>;
  locale?: Maybe<UpdateDocumentLocaleInput>;
  configs?: Maybe<DocumentConfigInput>;
  /** Your datetime should be in ISO-8601 format */
  deadline_at?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['Int']>;
  whatsapp_template?: Maybe<WhatsappTemplateEnum>;
  /** An array of emails to set as watchers to the document */
  watchers?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface UpdateDocumentLocaleInput {
  timezone?: Maybe<Scalars['String']>;
  date_format?: Maybe<DateFormatEnum>;
}


export interface User {
  id: Scalars['UUID'];
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['TimestampScalar']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  company?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateScalar']>;
  founder: Scalars['Boolean'];
  user_hash?: Maybe<Scalars['String']>;
  nolt?: Maybe<Scalars['String']>;
  escavador?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  member?: Maybe<Member>;
  created_at: Scalars['TimestampScalar'];
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  /** @deprecated Deprecated in this version. */
  auth_methods?: Maybe<Array<Maybe<Provider>>>;
  settings?: Maybe<Setting>;
  locale?: Maybe<Locale>;
  mfa: Array<Maybe<MfaEnum>>;
  /** @deprecated Deprecated in this version. */
  statistics: Statistic;
  subscription?: Maybe<Subscription>;
  /** @deprecated Deprecated in this version. */
  group?: Maybe<Group>;
  /** @deprecated Deprecated in this version. */
  permissions?: Maybe<Permission>;
  /** @deprecated Deprecated in this version. */
  customer_id?: Maybe<Scalars['String']>;
  /** Autentique's Privacy */
  emails?: Maybe<Array<Maybe<EmailType>>>;
  /** Autentique's Privacy */
  socials?: Maybe<Array<Maybe<Social>>>;
  /** Autentique's Privacy */
  sessions?: Maybe<Array<Maybe<Session>>>;
  referred_by?: Maybe<Scalars['UUID']>;
  additional_configs?: Maybe<UserAdditionalConfigs>;
  hp_set?: Maybe<Scalars['Boolean']>;
  biometric_required?: Maybe<Scalars['Boolean']>;
}

export interface UserAdditionalConfigs {
  refusable?: Maybe<Scalars['Boolean']>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  reminder?: Maybe<ReminderEnum>;
  lock_user_data?: Maybe<Scalars['Boolean']>;
  signature_appearance?: Maybe<SignatureAppearanceEnum>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  days_before?: Maybe<Scalars['Int']>;
  email_section?: Maybe<Scalars['Boolean']>;
  appearance_section?: Maybe<Scalars['Boolean']>;
  reminder_section?: Maybe<Scalars['Boolean']>;
  miscellaneous_section?: Maybe<Scalars['Boolean']>;
  locale_section?: Maybe<Scalars['Boolean']>;
  notify_watchers?: Maybe<Scalars['Boolean']>;
}

export interface UserAdditionalConfigsInput {
  refusable?: Maybe<Scalars['Boolean']>;
  footer?: Maybe<FooterEnum>;
  footer_type?: Maybe<FooterTypeEnum>;
  reminder?: Maybe<ReminderEnum>;
  lock_user_data?: Maybe<Scalars['Boolean']>;
  signature_appearance?: Maybe<SignatureAppearanceEnum>;
  new_signature_style?: Maybe<Scalars['Boolean']>;
  scrolling_required?: Maybe<Scalars['Boolean']>;
  show_audit_page?: Maybe<Scalars['Boolean']>;
  stop_on_rejected?: Maybe<Scalars['Boolean']>;
  days_before?: Maybe<Scalars['Int']>;
  email_section?: Maybe<Scalars['Boolean']>;
  appearance_section?: Maybe<Scalars['Boolean']>;
  reminder_section?: Maybe<Scalars['Boolean']>;
  miscellaneous_section?: Maybe<Scalars['Boolean']>;
  locale_section?: Maybe<Scalars['Boolean']>;
  notify_watchers?: Maybe<Scalars['Boolean']>;
}

/** User biometric verification record */
export interface UserBiometricValidation {
  /** record ID */
  id: Scalars['String'];
  /** Biometrique operation ID */
  operation_id: Scalars['String'];
  /** Liveness session ID */
  session_id?: Maybe<Scalars['String']>;
  /** Number of attempts used */
  tries: Scalars['Int'];
  /** Remaining attempts before waiting approval */
  max_attempts: Scalars['Int'];
  /** Verification status */
  status: UserBiometricValidationStatusEnum;
  /** Verification result */
  result?: Maybe<BiometriqueResultEnum>;
  /** When verification succeeded */
  verified_at?: Maybe<Scalars['String']>;
  /** Operation metadata and extracted data */
  payload?: Maybe<UserBiometricValidationPayload>;
  /** Attempt logs history */
  logs_attempt?: Maybe<Scalars['ArrayScalar']>;
  /** The user who owns this verification */
  user?: Maybe<BlockedUser>;
  updated_at: Scalars['TimestampScalar'];
  created_at: Scalars['TimestampScalar'];
}

/** Payload data for a user biometric verification record */
export interface UserBiometricValidationPayload {
  /** Biometrique operation ID */
  operation_id?: Maybe<Scalars['String']>;
  /** Biometrique operation type */
  operation_type?: Maybe<Scalars['String']>;
  /** HTTP status from Biometrique */
  status?: Maybe<Scalars['Int']>;
  /** Document type detected by Biometrique */
  document_type?: Maybe<Scalars['String']>;
  /** Whether identity was verified */
  verified?: Maybe<Scalars['Boolean']>;
  /** Confidence score from Biometrique */
  confidence?: Maybe<Scalars['Float']>;
  /** Error or status code */
  code?: Maybe<Scalars['String']>;
  /** When operation was created at Biometrique */
  created_at?: Maybe<Scalars['String']>;
  /** Image URLs stored in the payload */
  image?: Maybe<UserBiometricValidationPayloadImage>;
  /** Extracted data JSON from document */
  extracted_data?: Maybe<Scalars['String']>;
}

/** Image URLs inside a user biometric validation payload */
export interface UserBiometricValidationPayloadImage {
  /** Selfie image URL */
  selfie?: Maybe<Scalars['String']>;
  /** Document front image URL */
  front?: Maybe<Scalars['String']>;
  /** Document back image URL */
  back?: Maybe<Scalars['String']>;
}

export enum UserBiometricValidationStatusEnum {
  /** DRAFT */
  Draft = 'DRAFT',
  /** PROCESSING */
  Processing = 'PROCESSING',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING_APPROVAL */
  WaitingApproval = 'WAITING_APPROVAL',
  /** APPROVED */
  Approved = 'APPROVED',
  /** REJECTED */
  Rejected = 'REJECTED'
}

export interface UserCloudCert {
  /** The serial number of the certificate */
  serial_number?: Maybe<Scalars['String']>;
  /** The type of the certificate */
  type?: Maybe<CloudSignaturesEnum>;
}

export interface UserData {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailScalar']>;
  phone?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['CPFScalar']>;
  cnpj?: Maybe<Scalars['CNPJScalar']>;
  company?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateScalar']>;
  signature_format?: Maybe<Scalars['String']>;
  initials_format?: Maybe<Scalars['String']>;
  signature_url?: Maybe<Scalars['String']>;
  initials_url?: Maybe<Scalars['String']>;
  font?: Maybe<FontEnum>;
}

export interface UserDetailInput {
  email: Scalars['EmailScalar'];
  password: Scalars['String'];
}

export interface UserInput {
  name?: Maybe<Scalars['FullNameScalar']>;
  email?: Maybe<Scalars['EmailScalar']>;
  password?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationInput>;
}

export interface UserSignatureInput {
  format: Scalars['String'];
  file_image?: Maybe<Scalars['Upload']>;
  file_draw?: Maybe<Scalars['Upload']>;
  font?: FontEnum;
  text?: Maybe<Scalars['String']>;
}

export interface VerifyBiometricAuthCombinedType {
  authentication?: Maybe<AuthenticationResult>;
  security_verification?: Maybe<SecurityVerificationType>;
}

export type VerifyBiometricAuthUnion = AuthenticationResult | SecurityVerificationType | VerifyBiometricAuthCombinedType;

export interface Watcher {
  email?: Maybe<Scalars['EmailScalar']>;
  user_id?: Maybe<Scalars['UUID']>;
  organization_id?: Maybe<Scalars['Int']>;
  group_id?: Maybe<Scalars['Int']>;
  folder_id?: Maybe<Scalars['UUID']>;
}

export interface WebhookEndpoint {
  id?: Maybe<Scalars['String']>;
  has_authorization_token?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  type?: Maybe<WebhookEndpointTypeEnum>;
  format?: Maybe<WebhookFormatEnum>;
  organization?: Maybe<Organization>;
  folder?: Maybe<Folder>;
  events?: Maybe<Array<Maybe<WebhookEventTypeEnum>>>;
  block_at?: Maybe<Scalars['TimestampScalar']>;
  updated_at?: Maybe<Scalars['TimestampScalar']>;
  created_at?: Maybe<Scalars['TimestampScalar']>;
  successful_attempts?: Maybe<Scalars['Int']>;
  failed_attempts?: Maybe<Scalars['Int']>;
  success_rate?: Maybe<Scalars['Float']>;
  requires_static_ip?: Maybe<Scalars['Boolean']>;
}

export enum WebhookEndpointTypeEnum {
  Document = 'DOCUMENT',
  Signature = 'SIGNATURE',
  Member = 'MEMBER'
}

export interface WebhookEvent {
  name: Scalars['String'];
  enum_key: Scalars['String'];
}

export interface WebhookEventGroup {
  object: WebhookEndpointTypeEnum;
  events?: Maybe<Array<Maybe<WebhookEvent>>>;
}

export enum WebhookEventTypeEnum {
  DocumentCreated = 'DOCUMENT_CREATED',
  DocumentUpdated = 'DOCUMENT_UPDATED',
  DocumentDeleted = 'DOCUMENT_DELETED',
  DocumentFinished = 'DOCUMENT_FINISHED',
  SignatureCreated = 'SIGNATURE_CREATED',
  SignatureUpdated = 'SIGNATURE_UPDATED',
  SignatureDeleted = 'SIGNATURE_DELETED',
  SignatureViewed = 'SIGNATURE_VIEWED',
  SignatureAccepted = 'SIGNATURE_ACCEPTED',
  SignatureRejected = 'SIGNATURE_REJECTED',
  SignatureBiometricApproved = 'SIGNATURE_BIOMETRIC_APPROVED',
  SignatureBiometricUnapproved = 'SIGNATURE_BIOMETRIC_UNAPPROVED',
  SignatureBiometricRejected = 'SIGNATURE_BIOMETRIC_REJECTED',
  SignatureDeliveryFailed = 'SIGNATURE_DELIVERY_FAILED',
  SignatureBiometricReset = 'SIGNATURE_BIOMETRIC_RESET',
  MemberCreated = 'MEMBER_CREATED',
  MemberDeleted = 'MEMBER_DELETED'
}

export enum WebhookFormatEnum {
  Urlencoded = 'URLENCODED',
  Json = 'JSON'
}

export enum WhatsappTemplateEnum {
  Standard = 'STANDARD',
  Formal = 'FORMAL',
  Casual = 'CASUAL',
  Direct = 'DIRECT'
}

export interface Whitelabel {
  domain?: Maybe<Scalars['String']>;
  sendgrid_domain?: Maybe<Scalars['String']>;
  sendgrid_email_user?: Maybe<Scalars['String']>;
  is_darkmode?: Maybe<Scalars['Boolean']>;
  main_color?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  pdf_logo?: Maybe<Scalars['String']>;
  pdf_logo_mini?: Maybe<Scalars['String']>;
  og_title?: Maybe<Scalars['String']>;
  og_description?: Maybe<Scalars['String']>;
  og_image?: Maybe<Scalars['String']>;
}

export interface WhitelabelAppearanceInput {
  main_color?: Maybe<Scalars['String']>;
  is_darkmode?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['Upload']>;
  pdf_logo?: Maybe<Scalars['Upload']>;
  pdf_logo_mini?: Maybe<Scalars['Upload']>;
}

export interface WhitelabelOpengraphInput {
  og_title?: Maybe<Scalars['String']>;
  og_description?: Maybe<Scalars['String']>;
  og_image?: Maybe<Scalars['URLScalar']>;
}

export interface WhitelabelSendgrid {
  whitelabel?: Maybe<Whitelabel>;
  sendgrid_dns?: Maybe<WhitelabelSendgridDns>;
}

export interface WhitelabelSendgridDns {
  valid?: Maybe<Scalars['Boolean']>;
  dns?: Maybe<Array<Maybe<WhitelabelSendgridDnsRecord>>>;
}

export interface WhitelabelSendgridDnsRecord {
  valid?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
}

export interface WhitelabelSendgridInput {
  sendgrid_domain?: Maybe<Scalars['String']>;
  sendgrid_email_user?: Maybe<Scalars['String']>;
}

export type SignatureEventFragment = (
  Pick<Event, 'ip' | 'port' | 'reason' | 'created_at'>
  & { geolocation?: Maybe<Pick<Geolocation, 'country' | 'countryISO' | 'state' | 'stateISO' | 'city' | 'zipcode' | 'latitude' | 'longitude'>> }
);

export type EventFragment = (
  Pick<Event, 'ip' | 'port' | 'reason' | 'created_at'>
  & { geolocation?: Maybe<Pick<Geolocation, 'country' | 'countryISO' | 'state' | 'stateISO' | 'city' | 'zipcode' | 'latitude' | 'longitude'>> }
);

export type EmailEventFragment = Pick<EmailEvent, 'delivered' | 'opened' | 'reason' | 'refused' | 'sent'>;

export type OauthClientFieldsFragment = Pick<OAuthClient, 'id' | 'name' | 'description' | 'icon_url' | 'redirect_uris' | 'scopes' | 'client_secret' | 'created_at'>;

export type DocumentAuthorFragment = Pick<Author, 'id' | 'email' | 'name' | 'company' | 'organization_id'>;

export type DocumentFileFragment = Pick<File, 'original' | 'signed' | 'certified' | 'pades'>;

export type SignatureTokenFragment = Pick<DocumentSignature, 'document_id' | 'signature_id' | 'signature_public_id' | 'type'>;

export type SlimOrganizationFragment = (
  Pick<Organization, 'id' | 'uuid' | 'name' | 'country'>
  & { subscription?: Maybe<Pick<Subscription, 'expires_at' | 'name'>> }
);

export type MemberPermissionsBaseFragment = Pick<Permission, 'create_documents' | 'archive_documents' | 'delete_documents' | 'sign_documents' | 'view_documents_gr' | 'actions_documents_gr' | 'actions_templates_gr' | 'view_documents_oz' | 'view_member_documents_oz' | 'view_member_folders_oz' | 'view_group_documents_oz' | 'view_invoices_oz' | 'actions_documents_oz' | 'actions_members_oz' | 'actions_groups_oz' | 'actions_webhooks_oz' | 'actions_applications_oz' | 'change_appearances_oz' | 'change_plan_oz' | 'validate_biometry'>;

export type MemberPermissionsFragment = (
  Pick<Permission, 'change_whitelabel_oz' | 'enterprise_access'>
  & MemberPermissionsBaseFragment
);

export type GroupPermissionsFragment = (
  Pick<Permission, 'overwrite_permissions'>
  & MemberPermissionsFragment
);

export type OrganizationGroupFragment = (
  Pick<Group, 'id' | 'uuid' | 'name' | 'cnpj' | 'company' | 'members_count' | 'is_default' | 'overwrite_template' | 'overwrite_template_group'>
  & { styles?: Maybe<Pick<GroupStyle, 'overwrite_email' | 'overwrite_name'>>, email_templates?: Maybe<Array<Maybe<Pick<EmailTemplates, 'id' | 'name' | 'type'>>>>, permissions?: Maybe<GroupPermissionsFragment> }
);

export type OrganizationMemberFragment = { user?: Maybe<Pick<User, 'id' | 'name' | 'email' | 'phone'>>, group?: Maybe<OrganizationGroupFragment>, permissions?: Maybe<MemberPermissionsBaseFragment> };

export type EmailDetailsFragment = Pick<EmailTemplate, 'colors' | 'footer' | 'image' | 'sender' | 'subject' | 'template' | 'text' | 'title'>;

export type EmailTemplateFragment = (
  Pick<EmailTemplates, 'id' | 'name' | 'type'>
  & { ptBR?: Maybe<EmailDetailsFragment>, enUS?: Maybe<EmailDetailsFragment>, esMX?: Maybe<EmailDetailsFragment> }
);

export type UserStatisticsFragment = Pick<Statistic, 'documents' | 'sent' | 'signatures'>;

export type UserSettingsFragment = (
  Pick<Setting, 'font' | 'format' | 'signature' | 'signature_draw' | 'signature_text' | 'initials_format' | 'initials' | 'initials_text' | 'initials_draw' | 'has_signature_appearance' | 'has_initials_appearance' | 'developer'>
  & { email?: Maybe<EmailDetailsFragment> }
);

export type UserOrganizationFragment = (
  Pick<Organization, 'id' | 'uuid' | 'name' | 'cnpj' | 'country' | 'type' | 'created_at'>
  & { locale?: Maybe<Pick<Locale, 'country' | 'language'>>, billing_customer?: Maybe<Pick<Customer, 'iugu_id' | 'stripe_id'>>, settings?: Maybe<Pick<Setting, 'webhook_url' | 'webhook_format'>>, parent?: Maybe<Pick<ParentOrganization, 'id' | 'name'>> }
);

export type UserBasicFragment = (
  Pick<User, 'id' | 'name' | 'email' | 'cpf' | 'biometric_required' | 'birthday' | 'founder' | 'company' | 'cnpj' | 'phone' | 'created_at' | 'email_verified_at' | 'user_hash' | 'nolt' | 'escavador' | 'mfa'>
  & { locale?: Maybe<Pick<Locale, 'country' | 'date_format' | 'language' | 'timezone'>> }
);

export type UserFragment = (
  Pick<User, 'hp_set'>
  & { subscription?: Maybe<Pick<Subscription, 'gateway_id' | 'gateway_name' | 'plan_id' | 'credits' | 'credits_bonus' | 'name' | 'documents' | 'bonus' | 'has_premium_features' | 'has_corporate_features' | 'created_at' | 'expires_at'>>, settings?: Maybe<UserSettingsFragment>, organization?: Maybe<(
    { parent?: Maybe<Pick<ParentOrganization, 'id' | 'name'>> }
    & UserOrganizationFragment
  )>, member?: Maybe<(
    { configs?: Maybe<MemberConfigsFragment> }
    & OrganizationMemberFragment
  )>, additional_configs?: Maybe<UserAdditionalConfigsFragment> }
  & UserBasicFragment
);

export type PositionsFragment = Pick<SignaturePosition, 'element' | 'x' | 'y' | 'z' | 'angle' | 'scale'>;

export type VerificationsFragment = (
  Pick<SecurityVerificationType, 'id' | 'type' | 'verified_at' | 'verify_phone' | 'max_attempt' | 'logs_attempt' | 'fallback_behavior'>
  & { user?: Maybe<UserVerificationFragment>, payload?: Maybe<VerificationPayloadFragment> }
);

export type UserVerificationFragment = (
  Pick<SecurityVerificationUserType, 'confidence' | 'images'>
  & { extracted_data?: Maybe<Pick<SecurityVerificationExtractedDataType, 'city' | 'cpf' | 'date_of_birth' | 'first_name' | 'last_name' | 'nationality'>> }
);

export type VerificationPayloadFragment = Pick<SecurityVerificationPayloadType, 'url' | 'reference' | 'expiry' | 'failcode' | 'code'>;

export type BasicSignerFragment = (
  Pick<Signature, 'public_id' | 'organization_id' | 'group_id'>
  & { signed?: Maybe<EventFragment>, signed_unapproved?: Maybe<EventFragment> }
);

export type WhitelabelFragment = Pick<Whitelabel, 'domain' | 'main_color' | 'is_darkmode' | 'logo' | 'pdf_logo' | 'pdf_logo_mini' | 'sendgrid_domain' | 'sendgrid_email_user' | 'og_title' | 'og_description' | 'og_image'>;

export type SendgridDnsFragment = (
  Pick<WhitelabelSendgridDns, 'valid'>
  & { dns?: Maybe<Array<Maybe<Pick<WhitelabelSendgridDnsRecord, 'valid' | 'type' | 'host' | 'data' | 'reason'>>>> }
);

export type InvoiceFragment = Pick<Invoice, 'currency' | 'description' | 'due_date' | 'payment_method' | 'price' | 'status' | 'id' | 'type' | 'url_nfse' | 'url_payment'>;

export type UserAdditionalConfigsFragment = Pick<UserAdditionalConfigs, 'appearance_section' | 'days_before' | 'email_section' | 'footer' | 'footer_type' | 'locale_section' | 'lock_user_data' | 'miscellaneous_section' | 'new_signature_style' | 'refusable' | 'reminder' | 'reminder_section' | 'scrolling_required' | 'show_audit_page' | 'signature_appearance' | 'stop_on_rejected' | 'notify_watchers'>;

export type MemberConfigsFragment = (
  Pick<MemberConfigs, 'email_template' | 'ignore_birthdate' | 'ignore_cpf' | 'locked_cc' | 'locked_reply_to' | 'locked_watchers' | 'notification_finished' | 'notification_signed' | 'ordered_signatures' | 'signature_type' | 'whatsapp_template'>
  & { folder?: Maybe<Pick<Folder, 'id' | 'name'>>, locale?: Maybe<Pick<Locale, 'country' | 'date_format' | 'language' | 'timezone'>>, locked_signers?: Maybe<Array<Maybe<(
    Pick<LockSignature, 'action' | 'delivery_method' | 'email' | 'name' | 'phone' | 'show_cpf_verification' | 'show_options' | 'show_security_verifications' | 'show_sms_verification' | 'qualified_signature'>
    & { configs?: Maybe<Pick<LockSignatureConfig, 'cpf' | 'cnpj'>>, security_verifications?: Maybe<Array<Maybe<Pick<SecurityVerificationType, 'type' | 'verify_phone' | 'fallback_behavior'>>>> }
  )>>> }
);

export type DynamicDocumentEventFragment = (
  Pick<Event, 'ip' | 'port' | 'field_values' | 'reason' | 'created_at'>
  & { geolocation?: Maybe<Pick<Geolocation, 'country' | 'countryISO' | 'state' | 'stateISO' | 'city' | 'zipcode' | 'latitude' | 'longitude'>> }
);

export type FaceLivenessResultFragment = Pick<FaceLivenessResult, 'confidence' | 'status'>;

export type UserBiometricValidationFragment = (
  Pick<UserBiometricValidation, 'created_at' | 'id' | 'operation_id' | 'max_attempts' | 'result' | 'session_id' | 'status' | 'tries' | 'verified_at' | 'updated_at'>
  & { payload?: Maybe<(
    Pick<UserBiometricValidationPayload, 'code' | 'confidence' | 'created_at' | 'document_type' | 'extracted_data' | 'operation_id' | 'operation_type' | 'status' | 'verified'>
    & { image?: Maybe<Pick<UserBiometricValidationPayloadImage, 'back' | 'front' | 'selfie'>> }
  )> }
);

export type PublicDocumentQueryVariables = Exact<{
  id?: Maybe<Scalars['UUID']>;
  publicId?: Maybe<Scalars['UUID']>;
}>;


export type PublicDocumentQuery = { document?: Maybe<PublicDocumentFragment> };

export type SignatureQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type SignatureQuery = { signature: SlimSignatureFragment };

export type SignatureStatusQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type SignatureStatusQuery = { signature: { signed?: Maybe<Pick<Event, 'created_at'>> } };

export type LinkSignatureQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type LinkSignatureQuery = { signatureByLink?: Maybe<SlimSignatureFragment> };

export type PublicSignTokensQueryVariables = Exact<{
  signatureId: Scalars['UUID'];
}>;


export type PublicSignTokensQuery = { signatures?: Maybe<Array<Maybe<SignatureTokenFragment>>> };

export type PublicDocumentFileQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublicDocumentFileQuery = { document?: Maybe<{ files?: Maybe<DocumentFileFragment> }> };

export type PublicDocumentHistoryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type PublicDocumentHistoryQuery = { documentEmailHistory?: Maybe<{ author: Pick<Author, 'id' | 'name' | 'email'>, signatures?: Maybe<Array<Maybe<PublicSignerHistoryFragment>>>, signers_history?: Maybe<Array<Maybe<(
      Pick<SignerHistory, 'created_at' | 'category'>
      & { user?: Maybe<(
        Pick<PublicSignature, 'public_id'>
        & { action?: Maybe<Pick<Action, 'name'>>, user?: Maybe<Pick<PublicUser, 'id' | 'name' | 'email' | 'phone'>> }
      )>, author?: Maybe<(
        Pick<PublicSignature, 'public_id'>
        & { user?: Maybe<Pick<PublicUser, 'id' | 'name' | 'email'>> }
      )> }
    )>>> }> };

export type ViewSignatureMutationVariables = Exact<{
  signatureId: Scalars['UUID'];
}>;


export type ViewSignatureMutation = { viewSignature?: Maybe<(
    Pick<PublicSignature, 'public_id'>
    & { viewed?: Maybe<EventFragment> }
  )> };

export type RejectSignatureMutationVariables = Exact<{
  signatureId: Scalars['UUID'];
  type: TypeEnum;
  reason?: Maybe<Scalars['String']>;
}>;


export type RejectSignatureMutation = { rejectSignature?: Maybe<(
    Pick<PublicSignature, 'public_id'>
    & { rejected?: Maybe<EventFragment> }
  )> };

export type SlimSignatureFragment = (
  Pick<PublicSignature, 'public_id'>
  & { document: Pick<PublicDocument, 'id'> }
);

export type PublicDocumentFragment = (
  { author: DocumentAuthorFragment, files?: Maybe<DocumentFileFragment>, hashes?: Maybe<Pick<Hash, 'sha2'>>, configs?: Maybe<Pick<DocumentConfig, 'notification_signed' | 'notification_finished' | 'signature_appearance' | 'lock_user_data' | 'pdfa'>>, signatures?: Maybe<Array<Maybe<(
    { fields_filled?: Maybe<DynamicDocumentEventFragment> }
    & PublicSignerFragment
  )>>> }
  & PublicBasicDocumentFragment
);

export type PublicBasicDocumentFragment = (
  Pick<PublicDocument, 'id' | 'name' | 'ignore_cpf' | 'ignore_birthdate' | 'refusable' | 'sortable' | 'qualified' | 'sandbox' | 'footer' | 'footer_type' | 'new_signature_style' | 'scrolling_required' | 'stop_on_rejected' | 'is_blocked' | 'created_at' | 'updated_at' | 'expiration_at' | 'deadline_at' | 'lifecycle_in' | 'show_audit_page' | 'is_from_api' | 'is_dynamic_document'>
  & { locale?: Maybe<Pick<Locale, 'language' | 'country' | 'date_format' | 'timezone'>> }
);

export type PublicSignerFragment = (
  Pick<PublicSignature, 'public_id' | 'email' | 'name' | 'parent' | 'created_at' | 'updated_at' | 'delivery_method' | 'dynamic_ids'>
  & { certificate?: Maybe<Pick<SignedCertificate, 'type' | 'email' | 'document' | 'name' | 'payload'>>, action?: Maybe<Pick<Action, 'name'>>, email_events?: Maybe<EmailEventFragment>, configs?: Maybe<(
    Pick<SignatureConfig, 'cpf' | 'cnpj' | 'overwrite_name' | 'overwrite_date' | 'session_behavior'>
    & { prefilled_fields?: Maybe<Pick<PrefilledFields, 'name' | 'email' | 'phone' | 'cpf' | 'birthdate' | 'country' | 'language'>> }
  )>, viewed?: Maybe<EventFragment>, signed?: Maybe<EventFragment>, rejected?: Maybe<EventFragment>, signed_unapproved?: Maybe<EventFragment>, biometric_approved?: Maybe<EventFragment>, biometric_rejected?: Maybe<EventFragment>, biometric_auto_rejected?: Maybe<EventFragment>, positions?: Maybe<Array<Maybe<PositionsFragment>>>, user_data?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'birthday' | 'company' | 'phone' | 'signature_format' | 'initials_format' | 'signature_url' | 'initials_url' | 'font'>>, user?: Maybe<(
    Pick<PublicUser, 'id' | 'email_verified_at' | 'hp_set' | 'escavador'>
    & { organization?: Maybe<Pick<Organization, 'id' | 'name'>>, member?: Maybe<{ user?: Maybe<Pick<User, 'id'>>, group?: Maybe<(
        Pick<Group, 'id' | 'company'>
        & { styles?: Maybe<Pick<GroupStyle, 'overwrite_email' | 'overwrite_name'>> }
      )> }>, settings?: Maybe<Pick<Setting, 'format' | 'initials_format' | 'font' | 'signature' | 'signature_text' | 'signature_draw' | 'initials' | 'initials_text' | 'initials_draw'>> }
  )>, verifications?: Maybe<Array<Maybe<VerificationsFragment>>> }
);

export type PublicSignerHistoryFragment = (
  Pick<PublicSignature, 'public_id' | 'email' | 'name' | 'created_at' | 'updated_at' | 'type'>
  & { certificate?: Maybe<Pick<SignedCertificate, 'type' | 'name' | 'document' | 'email' | 'payload'>>, action?: Maybe<Pick<Action, 'name'>>, signature_history?: Maybe<Array<Maybe<(
    Pick<SignatureHistory, 'id' | 'delivered' | 'email' | 'email_type' | 'opened' | 'phone' | 'reason' | 'refused' | 'sent' | 'type'>
    & { user?: Maybe<Pick<PublicUser, 'name' | 'email' | 'cpf' | 'phone'>> }
  )>>>, email_history?: Maybe<Array<Maybe<(
    Pick<EmailEvent, 'id' | 'type'>
    & { user?: Maybe<Pick<User, 'name' | 'email'>>, author?: Maybe<Pick<User, 'name' | 'email'>> }
    & EmailEventFragment
  )>>>, configs?: Maybe<(
    Pick<SignatureConfig, 'cpf' | 'overwrite_name' | 'overwrite_date'>
    & { prefilled_fields?: Maybe<Pick<PrefilledFields, 'name' | 'email' | 'phone' | 'cpf' | 'birthdate' | 'country' | 'language'>> }
  )>, viewed?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, signed?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, rejected?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, signed_unapproved?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, biometric_approved?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, biometric_rejected?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, biometric_auto_rejected?: Maybe<(
    { user?: Maybe<Pick<UserData, 'name' | 'email' | 'cpf' | 'phone'>> }
    & EventFragment
  )>, user?: Maybe<Pick<PublicUser, 'id' | 'name' | 'email' | 'cpf' | 'phone'>>, verifications?: Maybe<Array<Maybe<VerificationsFragment>>> }
);

export type OrganizationInvoicesQueryVariables = Exact<{
  organizationUuid: Scalars['String'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type OrganizationInvoicesQuery = { organizationInvoices?: Maybe<(
    Pick<InvoicePagination, 'current_page' | 'last_page' | 'total'>
    & { data?: Maybe<Array<Maybe<InvoiceFragment>>> }
  )> };

export type SignatureBySecurityVerificationCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type SignatureBySecurityVerificationCodeQuery = Pick<Query, 'signatureBySecurityVerificationCode'>;

export type PrepareBiometricAuthMutationVariables = Exact<{
  document_id: Scalars['UUID'];
  security_verification_id: Scalars['Int'];
}>;


export type PrepareBiometricAuthMutation = Pick<Mutation, 'prepareBiometricAuth'>;

export type BiometricSignedUrlsQueryVariables = Exact<{
  operation_id: Scalars['String'];
}>;


export type BiometricSignedUrlsQuery = { biometricSignedUrls?: Maybe<Pick<BiometriqueSignedUrls, 'back_side' | 'front_side' | 'selfie'>> };

export type CreateUserBiometricLivenessSessionMutationVariables = Exact<{
  operation_id: Scalars['String'];
}>;


export type CreateUserBiometricLivenessSessionMutation = Pick<Mutation, 'createUserBiometricLivenessSession'>;

export type CheckUserBiometricLivenessResultsMutationVariables = Exact<{
  operation_id: Scalars['String'];
}>;


export type CheckUserBiometricLivenessResultsMutation = { checkUserBiometricLivenessResults?: Maybe<FaceLivenessResultFragment> };

export type ExecuteUserBiometricValidationMutationVariables = Exact<{
  configs?: Maybe<BiometriqueConfigsInput>;
  operation_id: Scalars['String'];
}>;


export type ExecuteUserBiometricValidationMutation = { executeUserBiometricValidation?: Maybe<UserBiometricValidationFragment> };

export type UserBiometricValidationQueryVariables = Exact<{
  operation_id: Scalars['String'];
}>;


export type UserBiometricValidationQuery = { userBiometricValidation?: Maybe<UserBiometricValidationFragment> };

export type WhitelabelByDomainQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type WhitelabelByDomainQuery = { whitelabelByDomain?: Maybe<WhitelabelFragment> };

export type WhitelabelByDocumentQueryVariables = Exact<{
  documentId: Scalars['UUID'];
}>;


export type WhitelabelByDocumentQuery = { whitelabelByDocument?: Maybe<WhitelabelFragment> };

export const SignatureEventFragmentDoc = gql`
    fragment signatureEvent on Event {
  ip
  port
  reason
  created_at
  geolocation {
    country
    countryISO
    state
    stateISO
    city
    zipcode
    latitude
    longitude
  }
}
    `;
export const OauthClientFieldsFragmentDoc = gql`
    fragment oauthClientFields on OAuthClient {
  id
  name
  description
  icon_url
  redirect_uris
  scopes
  client_secret
  created_at
}
    `;
export const SignatureTokenFragmentDoc = gql`
    fragment signatureToken on DocumentSignature {
  document_id
  signature_id
  signature_public_id
  type
}
    `;
export const SlimOrganizationFragmentDoc = gql`
    fragment slimOrganization on Organization {
  id
  uuid
  name
  country
  subscription {
    expires_at
    name
  }
}
    `;
export const EmailDetailsFragmentDoc = gql`
    fragment emailDetails on EmailTemplate {
  colors
  footer
  image
  sender
  subject
  template
  text
  title
}
    `;
export const EmailTemplateFragmentDoc = gql`
    fragment emailTemplate on EmailTemplates {
  id
  name
  type
  ptBR {
    ...emailDetails
  }
  enUS {
    ...emailDetails
  }
  esMX {
    ...emailDetails
  }
}
    ${EmailDetailsFragmentDoc}`;
export const UserStatisticsFragmentDoc = gql`
    fragment userStatistics on Statistic {
  documents
  sent
  signatures
}
    `;
export const UserBasicFragmentDoc = gql`
    fragment userBasic on User {
  id
  name
  email
  cpf
  biometric_required
  birthday
  founder
  company
  cnpj
  phone
  created_at
  email_verified_at
  user_hash
  nolt
  escavador
  mfa
  locale {
    country
    date_format
    language
    timezone
  }
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment userSettings on Setting {
  font
  format
  signature
  signature_draw
  signature_text
  initials_format
  initials
  initials_text
  initials_draw
  has_signature_appearance
  has_initials_appearance
  developer
  email {
    ...emailDetails
  }
}
    ${EmailDetailsFragmentDoc}`;
export const UserOrganizationFragmentDoc = gql`
    fragment userOrganization on Organization {
  id
  uuid
  name
  cnpj
  country
  locale {
    country
    language
  }
  type
  created_at
  billing_customer {
    iugu_id
    stripe_id
  }
  settings {
    webhook_url
    webhook_format
  }
  parent {
    id
    name
  }
}
    `;
export const MemberPermissionsBaseFragmentDoc = gql`
    fragment memberPermissionsBase on Permission {
  create_documents
  archive_documents
  delete_documents
  sign_documents
  view_documents_gr
  actions_documents_gr
  actions_templates_gr
  view_documents_oz
  view_member_documents_oz
  view_member_folders_oz
  view_group_documents_oz
  view_invoices_oz
  actions_documents_oz
  actions_members_oz
  actions_groups_oz
  actions_webhooks_oz
  actions_applications_oz
  change_appearances_oz
  change_plan_oz
  validate_biometry
}
    `;
export const MemberPermissionsFragmentDoc = gql`
    fragment memberPermissions on Permission {
  ...memberPermissionsBase
  change_whitelabel_oz
  enterprise_access
}
    ${MemberPermissionsBaseFragmentDoc}`;
export const GroupPermissionsFragmentDoc = gql`
    fragment groupPermissions on Permission {
  overwrite_permissions
  ...memberPermissions
}
    ${MemberPermissionsFragmentDoc}`;
export const OrganizationGroupFragmentDoc = gql`
    fragment organizationGroup on Group {
  id
  uuid
  name
  cnpj
  company
  members_count
  is_default
  overwrite_template
  overwrite_template_group
  styles {
    overwrite_email
    overwrite_name
  }
  email_templates {
    id
    name
    type
  }
  permissions {
    ...groupPermissions
  }
}
    ${GroupPermissionsFragmentDoc}`;
export const OrganizationMemberFragmentDoc = gql`
    fragment organizationMember on Member {
  user {
    id
    name
    email
    phone
  }
  group {
    ...organizationGroup
  }
  permissions {
    ...memberPermissionsBase
  }
}
    ${OrganizationGroupFragmentDoc}
${MemberPermissionsBaseFragmentDoc}`;
export const MemberConfigsFragmentDoc = gql`
    fragment memberConfigs on MemberConfigs {
  email_template
  folder {
    id
    name
  }
  ignore_birthdate
  ignore_cpf
  locale {
    country
    date_format
    language
    timezone
  }
  locked_cc
  locked_reply_to
  locked_watchers
  locked_signers {
    action
    configs {
      cpf
      cnpj
    }
    delivery_method
    email
    name
    phone
    security_verifications {
      type
      verify_phone
      fallback_behavior
    }
    show_cpf_verification
    show_options
    show_security_verifications
    show_sms_verification
    qualified_signature
  }
  notification_finished
  notification_signed
  ordered_signatures
  signature_type
  whatsapp_template
}
    `;
export const UserAdditionalConfigsFragmentDoc = gql`
    fragment userAdditionalConfigs on UserAdditionalConfigs {
  appearance_section
  days_before
  email_section
  footer
  footer_type
  locale_section
  lock_user_data
  miscellaneous_section
  new_signature_style
  refusable
  reminder
  reminder_section
  scrolling_required
  show_audit_page
  signature_appearance
  stop_on_rejected
  notify_watchers
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  ...userBasic
  subscription {
    gateway_id
    gateway_name
    plan_id
    credits
    credits_bonus
    name
    documents
    bonus
    has_premium_features
    has_corporate_features
    created_at
    expires_at
  }
  settings {
    ...userSettings
  }
  organization {
    ...userOrganization
    parent {
      id
      name
    }
  }
  member {
    ...organizationMember
    configs {
      ...memberConfigs
    }
  }
  additional_configs {
    ...userAdditionalConfigs
  }
  hp_set
}
    ${UserBasicFragmentDoc}
${UserSettingsFragmentDoc}
${UserOrganizationFragmentDoc}
${OrganizationMemberFragmentDoc}
${MemberConfigsFragmentDoc}
${UserAdditionalConfigsFragmentDoc}`;
export const EventFragmentDoc = gql`
    fragment event on Event {
  ip
  port
  reason
  created_at
  geolocation {
    country
    countryISO
    state
    stateISO
    city
    zipcode
    latitude
    longitude
  }
}
    `;
export const BasicSignerFragmentDoc = gql`
    fragment basicSigner on Signature {
  public_id
  organization_id
  group_id
  signed {
    ...event
  }
  signed_unapproved {
    ...event
  }
}
    ${EventFragmentDoc}`;
export const WhitelabelFragmentDoc = gql`
    fragment whitelabel on Whitelabel {
  domain
  main_color
  is_darkmode
  logo
  pdf_logo
  pdf_logo_mini
  sendgrid_domain
  sendgrid_email_user
  og_title
  og_description
  og_image
}
    `;
export const SendgridDnsFragmentDoc = gql`
    fragment sendgridDns on WhitelabelSendgridDns {
  valid
  dns {
    valid
    type
    host
    data
    reason
  }
}
    `;
export const InvoiceFragmentDoc = gql`
    fragment invoice on Invoice {
  currency
  description
  due_date
  payment_method
  price
  status
  id
  type
  url_nfse
  url_payment
}
    `;
export const FaceLivenessResultFragmentDoc = gql`
    fragment faceLivenessResult on FaceLivenessResult {
  confidence
  status
}
    `;
export const UserBiometricValidationFragmentDoc = gql`
    fragment userBiometricValidation on UserBiometricValidation {
  created_at
  id
  operation_id
  max_attempts
  result
  session_id
  status
  tries
  verified_at
  updated_at
  payload {
    code
    confidence
    created_at
    document_type
    extracted_data
    image {
      back
      front
      selfie
    }
    operation_id
    operation_type
    status
    verified
  }
}
    `;
export const SlimSignatureFragmentDoc = gql`
    fragment slimSignature on PublicSignature {
  public_id
  document {
    id
  }
}
    `;
export const PublicBasicDocumentFragmentDoc = gql`
    fragment publicBasicDocument on PublicDocument {
  id
  name
  ignore_cpf
  ignore_birthdate
  refusable
  sortable
  qualified
  sandbox
  footer
  footer_type
  new_signature_style
  scrolling_required
  stop_on_rejected
  is_blocked
  created_at
  updated_at
  expiration_at
  deadline_at
  lifecycle_in
  new_signature_style
  show_audit_page
  locale {
    language
    country
    date_format
    timezone
  }
  is_from_api
  is_dynamic_document
}
    `;
export const DocumentAuthorFragmentDoc = gql`
    fragment documentAuthor on Author {
  id
  email
  name
  company
  organization_id
}
    `;
export const DocumentFileFragmentDoc = gql`
    fragment documentFile on File {
  original
  signed
  certified
  pades
}
    `;
export const EmailEventFragmentDoc = gql`
    fragment emailEvent on EmailEvent {
  delivered
  opened
  reason
  refused
  sent
}
    `;
export const PositionsFragmentDoc = gql`
    fragment positions on SignaturePosition {
  element
  x
  y
  z
  angle
  scale
}
    `;
export const UserVerificationFragmentDoc = gql`
    fragment userVerification on SecurityVerificationUserType {
  confidence
  images
  extracted_data {
    city
    cpf
    date_of_birth
    first_name
    last_name
    nationality
  }
}
    `;
export const VerificationPayloadFragmentDoc = gql`
    fragment verificationPayload on SecurityVerificationPayloadType {
  url
  reference
  expiry
  failcode
  code
}
    `;
export const VerificationsFragmentDoc = gql`
    fragment verifications on SecurityVerificationType {
  id
  type
  user {
    ...userVerification
  }
  payload {
    ...verificationPayload
  }
  verified_at
  verify_phone
  max_attempt
  logs_attempt
  fallback_behavior
}
    ${UserVerificationFragmentDoc}
${VerificationPayloadFragmentDoc}`;
export const PublicSignerFragmentDoc = gql`
    fragment publicSigner on PublicSignature {
  public_id
  email
  name
  parent
  certificate {
    type
    email
    document
    name
    payload
  }
  created_at
  updated_at
  action {
    name
  }
  delivery_method
  email_events {
    ...emailEvent
  }
  configs {
    cpf
    cnpj
    overwrite_name
    overwrite_date
    session_behavior
    prefilled_fields {
      name
      email
      phone
      cpf
      birthdate
      country
      language
    }
  }
  viewed {
    ...event
  }
  signed {
    ...event
  }
  rejected {
    ...event
  }
  signed_unapproved {
    ...event
  }
  biometric_approved {
    ...event
  }
  biometric_rejected {
    ...event
  }
  biometric_auto_rejected {
    ...event
  }
  positions {
    ...positions
  }
  user_data {
    name
    email
    cpf
    birthday
    company
    phone
    signature_format
    initials_format
    signature_url
    initials_url
    font
  }
  user {
    id
    email_verified_at
    hp_set
    escavador
    organization {
      id
      name
    }
    member {
      user {
        id
      }
      group {
        id
        company
        styles {
          overwrite_email
          overwrite_name
        }
      }
    }
    settings {
      format
      initials_format
      font
      signature
      signature_text
      signature_draw
      initials
      initials_text
      initials_draw
    }
  }
  verifications {
    ...verifications
  }
  dynamic_ids
}
    ${EmailEventFragmentDoc}
${EventFragmentDoc}
${PositionsFragmentDoc}
${VerificationsFragmentDoc}`;
export const DynamicDocumentEventFragmentDoc = gql`
    fragment dynamicDocumentEvent on Event {
  ip
  port
  field_values
  reason
  created_at
  geolocation {
    country
    countryISO
    state
    stateISO
    city
    zipcode
    latitude
    longitude
  }
}
    `;
export const PublicDocumentFragmentDoc = gql`
    fragment publicDocument on PublicDocument {
  ...publicBasicDocument
  author {
    ...documentAuthor
  }
  files {
    ...documentFile
  }
  hashes {
    sha2
  }
  configs {
    notification_signed
    notification_finished
    signature_appearance
    lock_user_data
    pdfa
  }
  signatures {
    ...publicSigner
    fields_filled {
      ...dynamicDocumentEvent
    }
  }
}
    ${PublicBasicDocumentFragmentDoc}
${DocumentAuthorFragmentDoc}
${DocumentFileFragmentDoc}
${PublicSignerFragmentDoc}
${DynamicDocumentEventFragmentDoc}`;
export const PublicSignerHistoryFragmentDoc = gql`
    fragment publicSignerHistory on PublicSignature {
  public_id
  email
  name
  created_at
  updated_at
  type
  certificate {
    type
    name
    document
    email
    payload
  }
  action {
    name
  }
  signature_history {
    id
    delivered
    email
    email_type
    opened
    phone
    reason
    refused
    sent
    type
    user {
      name
      email
      cpf
      phone
    }
  }
  email_history {
    id
    type
    user {
      name
      email
    }
    author {
      name
      email
    }
    ...emailEvent
  }
  configs {
    cpf
    overwrite_name
    overwrite_date
    prefilled_fields {
      name
      email
      phone
      cpf
      birthdate
      country
      language
    }
  }
  viewed {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  signed {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  rejected {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  signed_unapproved {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  biometric_approved {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  biometric_rejected {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  biometric_auto_rejected {
    user {
      name
      email
      cpf
      phone
    }
    ...event
  }
  user {
    id
    name
    email
    cpf
    phone
  }
  verifications {
    ...verifications
  }
}
    ${EmailEventFragmentDoc}
${EventFragmentDoc}
${VerificationsFragmentDoc}`;
export const PublicDocumentDocument = gql`
    query PublicDocument($id: UUID, $publicId: UUID) {
  document(id: $id, public_id: $publicId) {
    ...publicDocument
  }
}
    ${PublicDocumentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicDocumentGQL extends Apollo.Query<PublicDocumentQuery, PublicDocumentQueryVariables> {
    document = PublicDocumentDocument;
    client = 'public';
  }
export const SignatureDocument = gql`
    query Signature($documentId: UUID!) {
  signature(id: $documentId) {
    ...slimSignature
  }
}
    ${SlimSignatureFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SignatureGQL extends Apollo.Query<SignatureQuery, SignatureQueryVariables> {
    document = SignatureDocument;
    client = 'public';
  }
export const SignatureStatusDocument = gql`
    query SignatureStatus($documentId: UUID!) {
  signature(id: $documentId) {
    signed {
      created_at
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignatureStatusGQL extends Apollo.Query<SignatureStatusQuery, SignatureStatusQueryVariables> {
    document = SignatureStatusDocument;
    client = 'public';
  }
export const LinkSignatureDocument = gql`
    query LinkSignature($documentId: UUID!) {
  signatureByLink(id: $documentId) {
    ...slimSignature
  }
}
    ${SlimSignatureFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LinkSignatureGQL extends Apollo.Query<LinkSignatureQuery, LinkSignatureQueryVariables> {
    document = LinkSignatureDocument;
    client = 'public';
  }
export const PublicSignTokensDocument = gql`
    query PublicSignTokens($signatureId: UUID!) {
  signatures(id: $signatureId) {
    ...signatureToken
  }
}
    ${SignatureTokenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicSignTokensGQL extends Apollo.Query<PublicSignTokensQuery, PublicSignTokensQueryVariables> {
    document = PublicSignTokensDocument;
    client = 'public';
  }
export const PublicDocumentFileDocument = gql`
    query PublicDocumentFile($id: UUID!) {
  document(id: $id) {
    files {
      ...documentFile
    }
  }
}
    ${DocumentFileFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicDocumentFileGQL extends Apollo.Query<PublicDocumentFileQuery, PublicDocumentFileQueryVariables> {
    document = PublicDocumentFileDocument;
    client = 'public';
  }
export const PublicDocumentHistoryDocument = gql`
    query PublicDocumentHistory($id: UUID!) {
  documentEmailHistory(id: $id) {
    author {
      id
      name
      email
    }
    signatures {
      ...publicSignerHistory
    }
    signers_history {
      created_at
      category
      user {
        public_id
        action {
          name
        }
        user {
          id
          name
          email
          phone
        }
      }
      author {
        public_id
        user {
          id
          name
          email
        }
      }
    }
  }
}
    ${PublicSignerHistoryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicDocumentHistoryGQL extends Apollo.Query<PublicDocumentHistoryQuery, PublicDocumentHistoryQueryVariables> {
    document = PublicDocumentHistoryDocument;
    client = 'public';
  }
export const ViewSignatureDocument = gql`
    mutation ViewSignature($signatureId: UUID!) {
  viewSignature(id: $signatureId) {
    public_id
    viewed {
      ...event
    }
  }
}
    ${EventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewSignatureGQL extends Apollo.Mutation<ViewSignatureMutation, ViewSignatureMutationVariables> {
    document = ViewSignatureDocument;
    client = 'public';
  }
export const RejectSignatureDocument = gql`
    mutation RejectSignature($signatureId: UUID!, $type: TypeEnum!, $reason: String) {
  rejectSignature(id: $signatureId, type: $type, reason: $reason) {
    public_id
    rejected {
      ...event
    }
  }
}
    ${EventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RejectSignatureGQL extends Apollo.Mutation<RejectSignatureMutation, RejectSignatureMutationVariables> {
    document = RejectSignatureDocument;
    client = 'public';
  }
export const OrganizationInvoicesDocument = gql`
    query OrganizationInvoices($organizationUuid: String!, $limit: Int!, $page: Int!) {
  organizationInvoices(
    organization_uuid: $organizationUuid
    limit: $limit
    page: $page
  ) {
    current_page
    last_page
    total
    data {
      ...invoice
    }
  }
}
    ${InvoiceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationInvoicesGQL extends Apollo.Query<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables> {
    document = OrganizationInvoicesDocument;
    client = 'public';
  }
export const SignatureBySecurityVerificationCodeDocument = gql`
    query SignatureBySecurityVerificationCode($code: String!) {
  signatureBySecurityVerificationCode(code: $code)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignatureBySecurityVerificationCodeGQL extends Apollo.Query<SignatureBySecurityVerificationCodeQuery, SignatureBySecurityVerificationCodeQueryVariables> {
    document = SignatureBySecurityVerificationCodeDocument;
    client = 'public';
  }
export const PrepareBiometricAuthDocument = gql`
    mutation prepareBiometricAuth($document_id: UUID!, $security_verification_id: Int!) {
  prepareBiometricAuth(
    document_id: $document_id
    security_verification_id: $security_verification_id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PrepareBiometricAuthGQL extends Apollo.Mutation<PrepareBiometricAuthMutation, PrepareBiometricAuthMutationVariables> {
    document = PrepareBiometricAuthDocument;
    client = 'public';
  }
export const BiometricSignedUrlsDocument = gql`
    query BiometricSignedUrls($operation_id: String!) {
  biometricSignedUrls(operation_id: $operation_id) {
    back_side
    front_side
    selfie
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BiometricSignedUrlsGQL extends Apollo.Query<BiometricSignedUrlsQuery, BiometricSignedUrlsQueryVariables> {
    document = BiometricSignedUrlsDocument;
    client = 'public';
  }
export const CreateUserBiometricLivenessSessionDocument = gql`
    mutation CreateUserBiometricLivenessSession($operation_id: String!) {
  createUserBiometricLivenessSession(operation_id: $operation_id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserBiometricLivenessSessionGQL extends Apollo.Mutation<CreateUserBiometricLivenessSessionMutation, CreateUserBiometricLivenessSessionMutationVariables> {
    document = CreateUserBiometricLivenessSessionDocument;
    client = 'public';
  }
export const CheckUserBiometricLivenessResultsDocument = gql`
    mutation checkUserBiometricLivenessResults($operation_id: String!) {
  checkUserBiometricLivenessResults(operation_id: $operation_id) {
    ...faceLivenessResult
  }
}
    ${FaceLivenessResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckUserBiometricLivenessResultsGQL extends Apollo.Mutation<CheckUserBiometricLivenessResultsMutation, CheckUserBiometricLivenessResultsMutationVariables> {
    document = CheckUserBiometricLivenessResultsDocument;
    client = 'public';
  }
export const ExecuteUserBiometricValidationDocument = gql`
    mutation executeUserBiometricValidation($configs: BiometriqueConfigsInput, $operation_id: String!) {
  executeUserBiometricValidation(configs: $configs, operation_id: $operation_id) {
    ...userBiometricValidation
  }
}
    ${UserBiometricValidationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExecuteUserBiometricValidationGQL extends Apollo.Mutation<ExecuteUserBiometricValidationMutation, ExecuteUserBiometricValidationMutationVariables> {
    document = ExecuteUserBiometricValidationDocument;
    client = 'public';
  }
export const UserBiometricValidationDocument = gql`
    query userBiometricValidation($operation_id: String!) {
  userBiometricValidation(operation_id: $operation_id) {
    ...userBiometricValidation
  }
}
    ${UserBiometricValidationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserBiometricValidationGQL extends Apollo.Query<UserBiometricValidationQuery, UserBiometricValidationQueryVariables> {
    document = UserBiometricValidationDocument;
    client = 'public';
  }
export const WhitelabelByDomainDocument = gql`
    query WhitelabelByDomain($domain: String!) {
  whitelabelByDomain(domain: $domain) {
    ...whitelabel
  }
}
    ${WhitelabelFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class WhitelabelByDomainGQL extends Apollo.Query<WhitelabelByDomainQuery, WhitelabelByDomainQueryVariables> {
    document = WhitelabelByDomainDocument;
    client = 'public';
  }
export const WhitelabelByDocumentDocument = gql`
    query WhitelabelByDocument($documentId: UUID!) {
  whitelabelByDocument(document_id: $documentId) {
    ...whitelabel
  }
}
    ${WhitelabelFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class WhitelabelByDocumentGQL extends Apollo.Query<WhitelabelByDocumentQuery, WhitelabelByDocumentQueryVariables> {
    document = WhitelabelByDocumentDocument;
    client = 'public';
  }